var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBackground(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "svg2",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 793.3 1122.7",
    enableBackground: "new 0 0 793.3 1122.7",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "g10",
    transform: "matrix(1.3333333,0,0,-1.3333333,0,1122.6667)"
  }, /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.7493 0 0 -0.75 52.6802 57.8018)",
    fontFamily: "'KozGoPr6N-Regular-83pv-RKSJ-H'",
    fontSize: "8.1415px"
  }, "\u5099"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.7493 0 0 -0.75 58.9201 57.8018)",
    fontFamily: "'KozGoPr6N-Regular-83pv-RKSJ-H'",
    fontSize: "8.1415px"
  }, "\u8003"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.7493 0 0 -0.75 66.1201 77.1217)",
    fontFamily: "'KozGoPr6N-Regular-83pv-RKSJ-H'",
    fontSize: "8.1415px"
  }, "\u5DEE"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.7493 0 0 -0.75 78.479 77.1217)",
    fontFamily: "'KozGoPr6N-Regular-83pv-RKSJ-H'",
    fontSize: "8.1415px"
  }, "\u5F15"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.7493 0 0 -0.75 90.8379 77.1217)",
    fontFamily: "'KozGoPr6N-Regular-83pv-RKSJ-H'",
    fontSize: "8.1415px"
  }, "\u5408"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.7493 0 0 -0.75 103.318 77.1217)",
    fontFamily: "'KozGoPr6N-Regular-83pv-RKSJ-H'",
    fontSize: "8.1415px"
  }, "\u8A08"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.7493 0 0 -0.75 115.6769 77.1217)",
    fontFamily: "'KozGoPr6N-Regular-83pv-RKSJ-H'",
    fontSize: "8.1415px"
  }, "\u7FCC"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.7493 0 0 -0.75 128.157 77.1217)",
    fontFamily: "'KozGoPr6N-Regular-83pv-RKSJ-H'",
    fontSize: "8.1415px"
  }, "\u671F"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.7493 0 0 -0.75 140.5159 77.1217)",
    fontFamily: "'KozGoPr6N-Regular-83pv-RKSJ-H'",
    fontSize: "8.1415px"
  }, "\u3078"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.7493 0 0 -0.75 152.996 77.1217)",
    fontFamily: "'KozGoPr6N-Regular-83pv-RKSJ-H'",
    fontSize: "8.1415px"
  }, "\u306E"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.7493 0 0 -0.75 165.3553 77.1217)",
    fontFamily: "'KozGoPr6N-Regular-83pv-RKSJ-H'",
    fontSize: "8.1415px"
  }, "\u7E70"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.7493 0 0 -0.75 177.835 77.1217)",
    fontFamily: "'KozGoPr6N-Regular-83pv-RKSJ-H'",
    fontSize: "8.1415px"
  }, "\u8D8A"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.7493 0 0 -0.75 190.1939 77.1217)",
    fontFamily: "'KozGoPr6N-Regular-83pv-RKSJ-H'",
    fontSize: "8.1415px"
  }, "\u984D"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.7493 0 0 -0.75 95.8799 67.762)",
    fontFamily: "'KozGoPr6N-Regular-83pv-RKSJ-H'",
    fontSize: "8.1415px"
  }, "("), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.7493 0 0 -0.75 99 67.762)",
    fontFamily: "'KozGoPr6N-Regular-83pv-RKSJ-H'",
    fontSize: "8.1415px"
  }, "2"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.7493 0 0 -0.75 102.1201 67.762)",
    fontFamily: "'KozGoPr6N-Regular-83pv-RKSJ-H'",
    fontSize: "8.1415px"
  }, "9"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.7493 0 0 -0.75 105.2399 67.762)",
    fontFamily: "'KozGoPr6N-Regular-83pv-RKSJ-H'",
    fontSize: "8.1415px"
  }, ")"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.7493 0 0 -0.75 108.72 67.762)",
    fontFamily: "'KozGoPr6N-Regular-83pv-RKSJ-H'",
    fontSize: "8.1415px"
  }, "\uFF0B"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.7493 0 0 -0.75 115.3199 67.762)",
    fontFamily: "'KozGoPr6N-Regular-83pv-RKSJ-H'",
    fontSize: "8.1415px"
  }, "("), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.7493 0 0 -0.75 118.44 67.762)",
    fontFamily: "'KozGoPr6N-Regular-83pv-RKSJ-H'",
    fontSize: "8.1415px"
  }, "3"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.7493 0 0 -0.75 121.5601 67.762)",
    fontFamily: "'KozGoPr6N-Regular-83pv-RKSJ-H'",
    fontSize: "8.1415px"
  }, "0"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.7493 0 0 -0.75 124.6802 67.762)",
    fontFamily: "'KozGoPr6N-Regular-83pv-RKSJ-H'",
    fontSize: "8.1415px"
  }, ")"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.7493 0 0 -0.75 128.1599 67.762)",
    fontFamily: "'KozGoPr6N-Regular-83pv-RKSJ-H'",
    fontSize: "8.1415px"
  }, "\uFF0D"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.7493 0 0 -0.75 134.7598 67.762)",
    fontFamily: "'KozGoPr6N-Regular-83pv-RKSJ-H'",
    fontSize: "8.1415px"
  }, "("), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.7493 0 0 -0.75 137.8799 67.762)",
    fontFamily: "'KozGoPr6N-Regular-83pv-RKSJ-H'",
    fontSize: "8.1415px"
  }, "3"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.7493 0 0 -0.75 141 67.762)",
    fontFamily: "'KozGoPr6N-Regular-83pv-RKSJ-H'",
    fontSize: "8.1415px"
  }, "1"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.7493 0 0 -0.75 144.1201 67.762)",
    fontFamily: "'KozGoPr6N-Regular-83pv-RKSJ-H'",
    fontSize: "8.1415px"
  }, ")"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.7493 0 0 -0.75 147.5999 67.762)",
    fontFamily: "'KozGoPr6N-Regular-83pv-RKSJ-H'",
    fontSize: "8.1415px"
  }, "\uFF0D"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.7493 0 0 -0.75 154.1998 67.762)",
    fontFamily: "'KozGoPr6N-Regular-83pv-RKSJ-H'",
    fontSize: "8.1415px"
  }, "("), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.7493 0 0 -0.75 157.3199 67.762)",
    fontFamily: "'KozGoPr6N-Regular-83pv-RKSJ-H'",
    fontSize: "8.1415px"
  }, "3"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.7493 0 0 -0.75 160.44 67.762)",
    fontFamily: "'KozGoPr6N-Regular-83pv-RKSJ-H'",
    fontSize: "8.1415px"
  }, "2"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.7493 0 0 -0.75 163.5601 67.762)",
    fontFamily: "'KozGoPr6N-Regular-83pv-RKSJ-H'",
    fontSize: "8.1415px"
  }, ")"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.7493 0 0 -0.75 203.7598 72.4422)",
    fontFamily: "'KozGoPr6N-Regular-83pv-RKSJ-H'",
    fontSize: "8.1415px"
  }, "3"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.7493 0 0 -0.75 206.8799 72.4422)",
    fontFamily: "'KozGoPr6N-Regular-83pv-RKSJ-H'",
    fontSize: "8.1415px"
  }, "3"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.7493 0 0 -0.75 406.9198 142.2823)",
    fontFamily: "'KozGoPr6N-Regular-83pv-RKSJ-H'",
    fontSize: "8.1415px"
  }, "\u5916"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.7493 0 0 -0.75 470.2794 142.2823)",
    fontFamily: "'KozGoPr6N-Regular-83pv-RKSJ-H'",
    fontSize: "8.1415px"
  }, "\u5916"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.7493 0 0 -0.75 77.0398 121.1622)",
    fontFamily: "'KozGoPr6N-Regular-83pv-RKSJ-H'",
    fontSize: "8.1415px"
  }, "\u8A8D"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.7493 0 0 -0.75 77.0398 104.1363)",
    fontFamily: "'KozGoPr6N-Regular-83pv-RKSJ-H'",
    fontSize: "8.1415px"
  }, "\u5BB9"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.7493 0 0 -0.75 77.0398 86.9896)",
    fontFamily: "'KozGoPr6N-Regular-83pv-RKSJ-H'",
    fontSize: "8.1415px"
  }, "\u984D"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.7493 0 0 -0.75 69.8401 121.1622)",
    fontFamily: "'KozGoPr6N-Regular-83pv-RKSJ-H'",
    fontSize: "8.1415px"
  }, "\u5F53"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.7493 0 0 -0.75 69.8401 109.8917)",
    fontFamily: "'KozGoPr6N-Regular-83pv-RKSJ-H'",
    fontSize: "8.1415px"
  }, "\u671F"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.7493 0 0 -0.75 69.8401 98.5011)",
    fontFamily: "'KozGoPr6N-Regular-83pv-RKSJ-H'",
    fontSize: "8.1415px"
  }, "\u640D"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.7493 0 0 -0.75 69.8401 86.9911)",
    fontFamily: "'KozGoPr6N-Regular-83pv-RKSJ-H'",
    fontSize: "8.1415px"
  }, "\u91D1"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.7493 0 0 -0.75 89.1599 114.6817)",
    fontFamily: "'KozGoPr6N-Regular-83pv-RKSJ-H'",
    fontSize: "8.1415px"
  }, "\u511F"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.7493 0 0 -0.75 101.7598 114.6817)",
    fontFamily: "'KozGoPr6N-Regular-83pv-RKSJ-H'",
    fontSize: "8.1415px"
  }, "\u5374"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.7493 0 0 -0.75 114.36 114.6817)",
    fontFamily: "'KozGoPr6N-Regular-83pv-RKSJ-H'",
    fontSize: "8.1415px"
  }, "\u4E0D"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.7493 0 0 -0.75 126.9602 114.6817)",
    fontFamily: "'KozGoPr6N-Regular-83pv-RKSJ-H'",
    fontSize: "8.1415px"
  }, "\u8DB3"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.7493 0 0 -0.75 139.5601 114.6817)",
    fontFamily: "'KozGoPr6N-Regular-83pv-RKSJ-H'",
    fontSize: "8.1415px"
  }, "\u306B"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.7493 0 0 -0.75 152.2801 114.6817)",
    fontFamily: "'KozGoPr6N-Regular-83pv-RKSJ-H'",
    fontSize: "8.1415px"
  }, "\u3088"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.7493 0 0 -0.75 164.8799 114.6817)",
    fontFamily: "'KozGoPr6N-Regular-83pv-RKSJ-H'",
    fontSize: "8.1415px"
  }, "\u308B"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.7493 0 0 -0.75 177.5999 114.6817)",
    fontFamily: "'KozGoPr6N-Regular-83pv-RKSJ-H'",
    fontSize: "8.1415px"
  }, "\u3082"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.7493 0 0 -0.75 190.1998 114.6817)",
    fontFamily: "'KozGoPr6N-Regular-83pv-RKSJ-H'",
    fontSize: "8.1415px"
  }, "\u306E"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.7493 0 0 -0.75 203.7591 114.6817)",
    fontFamily: "'KozGoPr6N-Regular-83pv-RKSJ-H'",
    fontSize: "8.1415px"
  }, "3"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.7493 0 0 -0.75 206.8792 114.6817)",
    fontFamily: "'KozGoPr6N-Regular-83pv-RKSJ-H'",
    fontSize: "8.1415px"
  }, "1"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.7493 0 0 -0.75 55.1997 134.3619)",
    fontFamily: "'KozGoPr6N-Regular-83pv-RKSJ-H'",
    fontSize: "8.1415px"
  }, "\u511F"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.7493 0 0 -0.75 55.1997 119.255)",
    fontFamily: "'KozGoPr6N-Regular-83pv-RKSJ-H'",
    fontSize: "8.1415px"
  }, "\u5374"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.7493 0 0 -0.75 55.1997 104.0279)",
    fontFamily: "'KozGoPr6N-Regular-83pv-RKSJ-H'",
    fontSize: "8.1415px"
  }, "\u8D85"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.7493 0 0 -0.75 55.1997 88.921)",
    fontFamily: "'KozGoPr6N-Regular-83pv-RKSJ-H'",
    fontSize: "8.1415px"
  }, "\u904E"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.7493 0 0 -0.75 55.1997 73.8133)",
    fontFamily: "'KozGoPr6N-Regular-83pv-RKSJ-H'",
    fontSize: "8.1415px"
  }, "\u984D"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.7493 0 0 -0.75 66.1201 135.8018)",
    fontFamily: "'KozGoPr6N-Regular-83pv-RKSJ-H'",
    fontSize: "8.1415px"
  }, "\u524D"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.7493 0 0 -0.75 83.8792 135.8018)",
    fontFamily: "'KozGoPr6N-Regular-83pv-RKSJ-H'",
    fontSize: "8.1415px"
  }, "\u671F"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.7493 0 0 -0.75 101.6382 135.8018)",
    fontFamily: "'KozGoPr6N-Regular-83pv-RKSJ-H'",
    fontSize: "8.1415px"
  }, "\u304B"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.7493 0 0 -0.75 119.3972 135.8018)",
    fontFamily: "'KozGoPr6N-Regular-83pv-RKSJ-H'",
    fontSize: "8.1415px"
  }, "\u3089"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.7493 0 0 -0.75 137.1559 135.8018)",
    fontFamily: "'KozGoPr6N-Regular-83pv-RKSJ-H'",
    fontSize: "8.1415px"
  }, "\u306E"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.7493 0 0 -0.75 154.7959 135.8018)",
    fontFamily: "'KozGoPr6N-Regular-83pv-RKSJ-H'",
    fontSize: "8.1415px"
  }, "\u7E70"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.7493 0 0 -0.75 172.555 135.8018)",
    fontFamily: "'KozGoPr6N-Regular-83pv-RKSJ-H'",
    fontSize: "8.1415px"
  }, "\u8D8A"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.7493 0 0 -0.75 190.195 135.8018)",
    fontFamily: "'KozGoPr6N-Regular-83pv-RKSJ-H'",
    fontSize: "8.1415px"
  }, "\u984D"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.7493 0 0 -0.75 203.754 135.8018)",
    fontFamily: "'KozGoPr6N-Regular-83pv-RKSJ-H'",
    fontSize: "8.1415px"
  }, "3"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.7493 0 0 -0.75 206.8741 135.8018)",
    fontFamily: "'KozGoPr6N-Regular-83pv-RKSJ-H'",
    fontSize: "8.1415px"
  }, "0"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.7493 0 0 -0.75 216.8401 142.2823)",
    fontFamily: "'KozGoPr6N-Regular-83pv-RKSJ-H'",
    fontSize: "8.1415px"
  }, "\u5916"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.7493 0 0 -0.75 280.199 142.2823)",
    fontFamily: "'KozGoPr6N-Regular-83pv-RKSJ-H'",
    fontSize: "8.1415px"
  }, "\u5916"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.7493 0 0 -0.75 343.558 142.2823)",
    fontFamily: "'KozGoPr6N-Regular-83pv-RKSJ-H'",
    fontSize: "8.1415px"
  }, "\u5916"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.7493 0 0 -0.75 89.1599 93.5616)",
    fontFamily: "'KozGoPr6N-Regular-83pv-RKSJ-H'",
    fontSize: "8.1415px"
  }, "\u7A4D"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.7493 0 0 -0.75 99.2399 93.5616)",
    fontFamily: "'KozGoPr6N-Regular-83pv-RKSJ-H'",
    fontSize: "8.1415px"
  }, "\u7ACB"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.7493 0 0 -0.75 109.3199 93.5616)",
    fontFamily: "'KozGoPr6N-Regular-83pv-RKSJ-H'",
    fontSize: "8.1415px"
  }, "\u91D1"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.7493 0 0 -0.75 119.4002 93.5616)",
    fontFamily: "'KozGoPr6N-Regular-83pv-RKSJ-H'",
    fontSize: "8.1415px"
  }, "\u53D6"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.7493 0 0 -0.75 129.4798 93.5616)",
    fontFamily: "'KozGoPr6N-Regular-83pv-RKSJ-H'",
    fontSize: "8.1415px"
  }, "\u5D29"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.7493 0 0 -0.75 139.5601 93.5616)",
    fontFamily: "'KozGoPr6N-Regular-83pv-RKSJ-H'",
    fontSize: "8.1415px"
  }, "\u3057"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.7493 0 0 -0.75 149.64 93.5616)",
    fontFamily: "'KozGoPr6N-Regular-83pv-RKSJ-H'",
    fontSize: "8.1415px"
  }, "\u306B"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.7493 0 0 -0.75 159.8401 93.5616)",
    fontFamily: "'KozGoPr6N-Regular-83pv-RKSJ-H'",
    fontSize: "8.1415px"
  }, "\u3088"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.7493 0 0 -0.75 169.9201 93.5616)",
    fontFamily: "'KozGoPr6N-Regular-83pv-RKSJ-H'",
    fontSize: "8.1415px"
  }, "\u308B"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.7493 0 0 -0.75 180.1202 93.5616)",
    fontFamily: "'KozGoPr6N-Regular-83pv-RKSJ-H'",
    fontSize: "8.1415px"
  }, "\u3082"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.7493 0 0 -0.75 190.1998 93.5616)",
    fontFamily: "'KozGoPr6N-Regular-83pv-RKSJ-H'",
    fontSize: "8.1415px"
  }, "\u306E"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.7493 0 0 -0.75 203.7591 93.5616)",
    fontFamily: "'KozGoPr6N-Regular-83pv-RKSJ-H'",
    fontSize: "8.1415px"
  }, "3"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.7493 0 0 -0.75 206.8792 93.5616)",
    fontFamily: "'KozGoPr6N-Regular-83pv-RKSJ-H'",
    fontSize: "8.1415px"
  }, "2"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.7493 0 0 -0.75 66.1201 161.6022)",
    fontFamily: "'KozGoPr6N-Regular-83pv-RKSJ-H'",
    fontSize: "8.1415px"
  }, "\u511F"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.7493 0 0 -0.75 97.199 161.6022)",
    fontFamily: "'KozGoPr6N-Regular-83pv-RKSJ-H'",
    fontSize: "8.1415px"
  }, "\u5374"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.7493 0 0 -0.75 128.1592 161.6022)",
    fontFamily: "'KozGoPr6N-Regular-83pv-RKSJ-H'",
    fontSize: "8.1415px"
  }, "\u8D85"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.7493 0 0 -0.75 159.2381 161.6022)",
    fontFamily: "'KozGoPr6N-Regular-83pv-RKSJ-H'",
    fontSize: "8.1415px"
  }, "\u904E"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.7493 0 0 -0.75 190.1979 161.6022)",
    fontFamily: "'KozGoPr6N-Regular-83pv-RKSJ-H'",
    fontSize: "8.1415px"
  }, "\u984D"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.7493 0 0 -0.75 115.44 152.2418)",
    fontFamily: "'KozGoPr6N-Regular-83pv-RKSJ-H'",
    fontSize: "8.1415px"
  }, "("), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.7493 0 0 -0.75 118.5601 152.2418)",
    fontFamily: "'KozGoPr6N-Regular-83pv-RKSJ-H'",
    fontSize: "8.1415px"
  }, "2"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.7493 0 0 -0.75 121.6802 152.2418)",
    fontFamily: "'KozGoPr6N-Regular-83pv-RKSJ-H'",
    fontSize: "8.1415px"
  }, "7"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.7493 0 0 -0.75 124.8 152.2418)",
    fontFamily: "'KozGoPr6N-Regular-83pv-RKSJ-H'",
    fontSize: "8.1415px"
  }, ")"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.7493 0 0 -0.75 128.2801 152.2418)",
    fontFamily: "'KozGoPr6N-Regular-83pv-RKSJ-H'",
    fontSize: "8.1415px"
  }, "\uFF0D"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.7493 0 0 -0.75 134.7598 152.2418)",
    fontFamily: "'KozGoPr6N-Regular-83pv-RKSJ-H'",
    fontSize: "8.1415px"
  }, "("), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.7493 0 0 -0.75 137.8799 152.2418)",
    fontFamily: "'KozGoPr6N-Regular-83pv-RKSJ-H'",
    fontSize: "8.1415px"
  }, "2"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.7493 0 0 -0.75 141 152.2418)",
    fontFamily: "'KozGoPr6N-Regular-83pv-RKSJ-H'",
    fontSize: "8.1415px"
  }, "6"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.7493 0 0 -0.75 144.1201 152.2418)",
    fontFamily: "'KozGoPr6N-Regular-83pv-RKSJ-H'",
    fontSize: "8.1415px"
  }, ")"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.7493 0 0 -0.75 203.7598 156.922)",
    fontFamily: "'KozGoPr6N-Regular-83pv-RKSJ-H'",
    fontSize: "8.1415px"
  }, "2"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.7493 0 0 -0.75 206.8799 156.922)",
    fontFamily: "'KozGoPr6N-Regular-83pv-RKSJ-H'",
    fontSize: "8.1415px"
  }, "9"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.7493 0 0 -0.75 55.1997 174.6817)",
    fontFamily: "'KozGoPr6N-Regular-83pv-RKSJ-H'",
    fontSize: "8.1415px"
  }, "\u5DEE"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.7493 0 0 -0.75 55.1997 160.2823)",
    fontFamily: "'KozGoPr6N-Regular-83pv-RKSJ-H'",
    fontSize: "8.1415px"
  }, "\u5F15"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.7493 0 0 -0.75 66.1201 182.7223)",
    fontFamily: "'KozGoPr6N-Regular-83pv-RKSJ-H'",
    fontSize: "8.1415px"
  }, "\u511F"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.7493 0 0 -0.75 97.199 182.7223)",
    fontFamily: "'KozGoPr6N-Regular-83pv-RKSJ-H'",
    fontSize: "8.1415px"
  }, "\u5374"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.7493 0 0 -0.75 128.1592 182.7223)",
    fontFamily: "'KozGoPr6N-Regular-83pv-RKSJ-H'",
    fontSize: "8.1415px"
  }, "\u4E0D"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.7493 0 0 -0.75 159.2381 182.7223)",
    fontFamily: "'KozGoPr6N-Regular-83pv-RKSJ-H'",
    fontSize: "8.1415px"
  }, "\u8DB3"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.7493 0 0 -0.75 190.1979 182.7223)",
    fontFamily: "'KozGoPr6N-Regular-83pv-RKSJ-H'",
    fontSize: "8.1415px"
  }, "\u984D"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.7493 0 0 -0.75 115.44 173.3619)",
    fontFamily: "'KozGoPr6N-Regular-83pv-RKSJ-H'",
    fontSize: "8.1415px"
  }, "("), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.7493 0 0 -0.75 118.5601 173.3619)",
    fontFamily: "'KozGoPr6N-Regular-83pv-RKSJ-H'",
    fontSize: "8.1415px"
  }, "2"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.7493 0 0 -0.75 121.6802 173.3619)",
    fontFamily: "'KozGoPr6N-Regular-83pv-RKSJ-H'",
    fontSize: "8.1415px"
  }, "6"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.7493 0 0 -0.75 124.8 173.3619)",
    fontFamily: "'KozGoPr6N-Regular-83pv-RKSJ-H'",
    fontSize: "8.1415px"
  }, ")"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.7493 0 0 -0.75 128.2801 173.3619)",
    fontFamily: "'KozGoPr6N-Regular-83pv-RKSJ-H'",
    fontSize: "8.1415px"
  }, "\uFF0D"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.7493 0 0 -0.75 134.7598 173.3619)",
    fontFamily: "'KozGoPr6N-Regular-83pv-RKSJ-H'",
    fontSize: "8.1415px"
  }, "("), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.7493 0 0 -0.75 137.8799 173.3619)",
    fontFamily: "'KozGoPr6N-Regular-83pv-RKSJ-H'",
    fontSize: "8.1415px"
  }, "2"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.7493 0 0 -0.75 141 173.3619)",
    fontFamily: "'KozGoPr6N-Regular-83pv-RKSJ-H'",
    fontSize: "8.1415px"
  }, "7"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.7493 0 0 -0.75 144.1201 173.3619)",
    fontFamily: "'KozGoPr6N-Regular-83pv-RKSJ-H'",
    fontSize: "8.1415px"
  }, ")"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.7493 0 0 -0.75 203.7598 178.0421)",
    fontFamily: "'KozGoPr6N-Regular-83pv-RKSJ-H'",
    fontSize: "8.1415px"
  }, "2"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.7493 0 0 -0.75 206.8799 178.0421)",
    fontFamily: "'KozGoPr6N-Regular-83pv-RKSJ-H'",
    fontSize: "8.1415px"
  }, "8"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.7493 0 0 -0.75 524.88 237.3221)",
    fontFamily: "'KozGoPr6N-Regular-83pv-RKSJ-H'",
    fontSize: "8.1415px"
  }, "\u5186"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.7493 0 0 -0.75 52.6802 199.1622)",
    fontFamily: "'KozGoPr6N-Regular-83pv-RKSJ-H'",
    fontSize: "8.1415px"
  }, "\u5F53"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.7493 0 0 -0.75 87.1201 199.1622)",
    fontFamily: "'KozGoPr6N-Regular-83pv-RKSJ-H'",
    fontSize: "8.1415px"
  }, "\u671F"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.7493 0 0 -0.75 121.44 199.1622)",
    fontFamily: "'KozGoPr6N-Regular-83pv-RKSJ-H'",
    fontSize: "8.1415px"
  }, "\u511F"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.7493 0 0 -0.75 155.8799 199.1622)",
    fontFamily: "'KozGoPr6N-Regular-83pv-RKSJ-H'",
    fontSize: "8.1415px"
  }, "\u5374"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.7493 0 0 -0.75 190.1998 199.1622)",
    fontFamily: "'KozGoPr6N-Regular-83pv-RKSJ-H'",
    fontSize: "8.1415px"
  }, "\u984D"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.7493 0 0 -0.75 203.7591 199.1622)",
    fontFamily: "'KozGoPr6N-Regular-83pv-RKSJ-H'",
    fontSize: "8.1415px"
  }, "2"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.7493 0 0 -0.75 206.8792 199.1622)",
    fontFamily: "'KozGoPr6N-Regular-83pv-RKSJ-H'",
    fontSize: "8.1415px"
  }, "7"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.7493 0 0 -0.75 52.6802 232.0421)",
    fontFamily: "'KozGoPr6N-Regular-83pv-RKSJ-H'",
    fontSize: "8.1415px"
  }, "\u5F53"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.7493 0 0 -0.75 66.4798 232.0421)",
    fontFamily: "'KozGoPr6N-Regular-83pv-RKSJ-H'",
    fontSize: "8.1415px"
  }, "\u671F"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.7493 0 0 -0.75 80.2801 232.0421)",
    fontFamily: "'KozGoPr6N-Regular-83pv-RKSJ-H'",
    fontSize: "8.1415px"
  }, "\u5206"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.7493 0 0 -0.75 94.08 232.0421)",
    fontFamily: "'KozGoPr6N-Regular-83pv-RKSJ-H'",
    fontSize: "8.1415px"
  }, "\u306E"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.7493 0 0 -0.75 107.7591 232.0421)",
    fontFamily: "'KozGoPr6N-Regular-83pv-RKSJ-H'",
    fontSize: "8.1415px"
  }, "\u666E"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.7493 0 0 -0.75 121.559 232.0421)",
    fontFamily: "'KozGoPr6N-Regular-83pv-RKSJ-H'",
    fontSize: "8.1415px"
  }, "\u901A"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.7493 0 0 -0.75 135.2381 232.0421)",
    fontFamily: "'KozGoPr6N-Regular-83pv-RKSJ-H'",
    fontSize: "8.1415px"
  }, "\u511F"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.7493 0 0 -0.75 149.038 232.0421)",
    fontFamily: "'KozGoPr6N-Regular-83pv-RKSJ-H'",
    fontSize: "8.1415px"
  }, "\u5374"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.7493 0 0 -0.75 162.7171 232.0421)",
    fontFamily: "'KozGoPr6N-Regular-83pv-RKSJ-H'",
    fontSize: "8.1415px"
  }, "\u9650"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.7493 0 0 -0.75 176.517 232.0421)",
    fontFamily: "'KozGoPr6N-Regular-83pv-RKSJ-H'",
    fontSize: "8.1415px"
  }, "\u5EA6"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.7493 0 0 -0.75 190.1961 232.0421)",
    fontFamily: "'KozGoPr6N-Regular-83pv-RKSJ-H'",
    fontSize: "8.1415px"
  }, "\u984D"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.7493 0 0 -0.75 79.08 218.9618)",
    fontFamily: "'KozGoPr6N-Regular-83pv-RKSJ-H'",
    fontSize: "8.1415px"
  }, "("), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.7493 0 0 -0.75 82.1997 218.9618)",
    fontFamily: "'KozGoPr6N-Regular-83pv-RKSJ-H'",
    fontSize: "8.1415px"
  }, "("), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.7493 0 0 -0.75 85.3198 218.9618)",
    fontFamily: "'KozGoPr6N-Regular-83pv-RKSJ-H'",
    fontSize: "8.1415px"
  }, "1"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.7493 0 0 -0.75 88.44 218.9618)",
    fontFamily: "'KozGoPr6N-Regular-83pv-RKSJ-H'",
    fontSize: "8.1415px"
  }, "0"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.7493 0 0 -0.75 91.5601 218.9618)",
    fontFamily: "'KozGoPr6N-Regular-83pv-RKSJ-H'",
    fontSize: "8.1415px"
  }, ")"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.7493 0 0 -0.75 95.0398 218.9618)",
    fontFamily: "'KozGoPr6N-Regular-83pv-RKSJ-H'",
    fontSize: "8.1415px"
  }, "\u3001"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.7493 0 0 -0.75 101.64 218.9618)",
    fontFamily: "'KozGoPr6N-Regular-83pv-RKSJ-H'",
    fontSize: "8.1415px"
  }, "("), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.7493 0 0 -0.75 104.7598 218.9618)",
    fontFamily: "'KozGoPr6N-Regular-83pv-RKSJ-H'",
    fontSize: "8.1415px"
  }, "1"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.7493 0 0 -0.75 107.8799 218.9618)",
    fontFamily: "'KozGoPr6N-Regular-83pv-RKSJ-H'",
    fontSize: "8.1415px"
  }, "6"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.7493 0 0 -0.75 111 218.9618)",
    fontFamily: "'KozGoPr6N-Regular-83pv-RKSJ-H'",
    fontSize: "8.1415px"
  }, ")"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.7493 0 0 -0.75 114.4798 218.9618)",
    fontFamily: "'KozGoPr6N-Regular-83pv-RKSJ-H'",
    fontSize: "8.1415px"
  }, "\u53C8"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.7493 0 0 -0.75 121.08 218.9618)",
    fontFamily: "'KozGoPr6N-Regular-83pv-RKSJ-H'",
    fontSize: "8.1415px"
  }, "\u306F"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.7493 0 0 -0.75 127.6802 218.9618)",
    fontFamily: "'KozGoPr6N-Regular-83pv-RKSJ-H'",
    fontSize: "8.1415px"
  }, "("), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.7493 0 0 -0.75 130.8 218.9618)",
    fontFamily: "'KozGoPr6N-Regular-83pv-RKSJ-H'",
    fontSize: "8.1415px"
  }, "1"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.7493 0 0 -0.75 133.9201 218.9618)",
    fontFamily: "'KozGoPr6N-Regular-83pv-RKSJ-H'",
    fontSize: "8.1415px"
  }, "9"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.7493 0 0 -0.75 137.0398 218.9618)",
    fontFamily: "'KozGoPr6N-Regular-83pv-RKSJ-H'",
    fontSize: "8.1415px"
  }, ")"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.7493 0 0 -0.75 140.1599 218.9618)",
    fontFamily: "'KozGoPr6N-Regular-83pv-RKSJ-H'",
    fontSize: "8.1415px"
  }, ")"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.7493 0 0 -0.75 143.64 218.9618)",
    fontFamily: "'KozGoPr6N-Regular-83pv-RKSJ-H'",
    fontSize: "8.1415px"
  }, "\xD7"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.7493 0 0 -0.75 203.7598 225.5616)",
    fontFamily: "'KozGoPr6N-Regular-83pv-RKSJ-H'",
    fontSize: "8.1415px"
  }, "2"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.7493 0 0 -0.75 206.8799 225.5616)",
    fontFamily: "'KozGoPr6N-Regular-83pv-RKSJ-H'",
    fontSize: "8.1415px"
  }, "6"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.7493 0 0 -0.75 271.44 237.3221)",
    fontFamily: "'KozGoPr6N-Regular-83pv-RKSJ-H'",
    fontSize: "8.1415px"
  }, "\u5186"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.7493 0 0 -0.75 334.7989 237.3221)",
    fontFamily: "'KozGoPr6N-Regular-83pv-RKSJ-H'",
    fontSize: "8.1415px"
  }, "\u5186"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.7493 0 0 -0.75 398.1578 237.3221)",
    fontFamily: "'KozGoPr6N-Regular-83pv-RKSJ-H'",
    fontSize: "8.1415px"
  }, "\u5186"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.7493 0 0 -0.75 461.5167 237.3221)",
    fontFamily: "'KozGoPr6N-Regular-83pv-RKSJ-H'",
    fontSize: "8.1415px"
  }, "\u5186"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.7493 0 0 -0.75 469.9198 279.5616)",
    fontFamily: "'KozGoPr6N-Regular-83pv-RKSJ-H'",
    fontSize: "8.1415px"
  }, "("), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.7493 0 0 -0.75 473.0399 279.5616)",
    fontFamily: "'KozGoPr6N-Regular-83pv-RKSJ-H'",
    fontSize: "8.1415px"
  }), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.7493 0 0 -0.75 479.2802 279.5616)",
    fontFamily: "'KozGoPr6N-Regular-83pv-RKSJ-H'",
    fontSize: "8.1415px"
  }), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.7493 0 0 -0.75 485.5204 279.5616)",
    fontFamily: "'KozGoPr6N-Regular-83pv-RKSJ-H'",
    fontSize: "8.1415px"
  }), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.7493 0 0 -0.75 491.7599 279.5616)",
    fontFamily: "'KozGoPr6N-Regular-83pv-RKSJ-H'",
    fontSize: "8.1415px"
  }), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.7493 0 0 -0.75 498.0001 279.5616)",
    fontFamily: "'KozGoPr6N-Regular-83pv-RKSJ-H'",
    fontSize: "8.1415px"
  }), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.7493 0 0 -0.75 504.2404 279.5616)",
    fontFamily: "'KozGoPr6N-Regular-83pv-RKSJ-H'",
    fontSize: "8.1415px"
  }), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.7493 0 0 -0.75 510.4799 279.5616)",
    fontFamily: "'KozGoPr6N-Regular-83pv-RKSJ-H'",
    fontSize: "8.1415px"
  }), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.7493 0 0 -0.75 516.7201 279.5616)",
    fontFamily: "'KozGoPr6N-Regular-83pv-RKSJ-H'",
    fontSize: "8.1415px"
  }), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.7493 0 0 -0.75 522.9603 279.5616)",
    fontFamily: "'KozGoPr6N-Regular-83pv-RKSJ-H'",
    fontSize: "8.1415px"
  }, ")"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.7493 0 0 -0.75 526.0797 279.5616)",
    fontFamily: "'KozGoPr6N-Regular-83pv-RKSJ-H'",
    fontSize: "8.1415px"
  }, "\u6708"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.7493 0 0 -0.75 52.6802 251.9618)",
    fontFamily: "'KozGoPr6N-Regular-83pv-RKSJ-H'",
    fontSize: "7.8745px"
  }, "\u5F53"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.7493 0 0 -0.75 58.9201 251.9618)",
    fontFamily: "'KozGoPr6N-Regular-83pv-RKSJ-H'",
    fontSize: "7.8745px"
  }, "\u671F"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.7493 0 0 -0.75 65.1599 251.9618)",
    fontFamily: "'KozGoPr6N-Regular-83pv-RKSJ-H'",
    fontSize: "7.8745px"
  }, "\u306B"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.7493 0 0 -0.75 71.4002 251.9618)",
    fontFamily: "'KozGoPr6N-Regular-83pv-RKSJ-H'",
    fontSize: "7.8745px"
  }, "\u304A"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.7493 0 0 -0.75 77.64 251.9618)",
    fontFamily: "'KozGoPr6N-Regular-83pv-RKSJ-H'",
    fontSize: "7.8745px"
  }, "\u3051"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.7493 0 0 -0.75 83.8799 251.9618)",
    fontFamily: "'KozGoPr6N-Regular-83pv-RKSJ-H'",
    fontSize: "7.8745px"
  }, "\u308B"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.7493 0 0 -0.75 90.1201 251.9618)",
    fontFamily: "'KozGoPr6N-Regular-83pv-RKSJ-H'",
    fontSize: "7.8745px"
  }, "\u30EA"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.7493 0 0 -0.75 96.36 251.9618)",
    fontFamily: "'KozGoPr6N-Regular-83pv-RKSJ-H'",
    fontSize: "7.8745px"
  }, "\u30FC"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.7493 0 0 -0.75 102.5999 251.9618)",
    fontFamily: "'KozGoPr6N-Regular-83pv-RKSJ-H'",
    fontSize: "7.8745px"
  }, "\u30B9"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.7493 0 0 -0.75 108.8401 251.9618)",
    fontFamily: "'KozGoPr6N-Regular-83pv-RKSJ-H'",
    fontSize: "7.8745px"
  }, "\u671F"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.7493 0 0 -0.75 115.08 251.9618)",
    fontFamily: "'KozGoPr6N-Regular-83pv-RKSJ-H'",
    fontSize: "7.8745px"
  }, "\u9593"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.7493 0 0 -0.75 121.3199 251.9618)",
    fontFamily: "'KozGoPr6N-Regular-83pv-RKSJ-H'",
    fontSize: "7.8745px"
  }, "\u53C8"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.7493 0 0 -0.75 127.5601 251.9618)",
    fontFamily: "'KozGoPr6N-Regular-83pv-RKSJ-H'",
    fontSize: "7.8745px"
  }, "\u306F"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.7493 0 0 -0.75 133.8 251.9618)",
    fontFamily: "'KozGoPr6N-Regular-83pv-RKSJ-H'",
    fontSize: "7.8745px"
  }, "\u6539"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.7493 0 0 -0.75 140.0398 251.9618)",
    fontFamily: "'KozGoPr6N-Regular-83pv-RKSJ-H'",
    fontSize: "7.8745px"
  }, "\u5B9A"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.7493 0 0 -0.75 146.4002 251.9618)",
    fontFamily: "'KozGoPr6N-Regular-83pv-RKSJ-H'",
    fontSize: "7.8745px"
  }, "\u30EA"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.7493 0 0 -0.75 152.6401 251.9618)",
    fontFamily: "'KozGoPr6N-Regular-83pv-RKSJ-H'",
    fontSize: "7.8745px"
  }, "\u30FC"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.7493 0 0 -0.75 159 251.9618)",
    fontFamily: "'KozGoPr6N-Regular-83pv-RKSJ-H'",
    fontSize: "7.8745px"
  }, "\u30B9"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.7493 0 0 -0.75 165.2399 251.9618)",
    fontFamily: "'KozGoPr6N-Regular-83pv-RKSJ-H'",
    fontSize: "7.8745px"
  }, "\u671F"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.7493 0 0 -0.75 171.5999 251.9618)",
    fontFamily: "'KozGoPr6N-Regular-83pv-RKSJ-H'",
    fontSize: "7.8745px"
  }, "\u9593"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.7493 0 0 -0.75 177.8401 251.9618)",
    fontFamily: "'KozGoPr6N-Regular-83pv-RKSJ-H'",
    fontSize: "7.8745px"
  }, "\u306E"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.7493 0 0 -0.75 184.1998 251.9618)",
    fontFamily: "'KozGoPr6N-Regular-83pv-RKSJ-H'",
    fontSize: "7.8745px"
  }, "\u6708"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.7493 0 0 -0.75 190.44 251.9618)",
    fontFamily: "'KozGoPr6N-Regular-83pv-RKSJ-H'",
    fontSize: "7.8745px"
  }, "\u6570"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.7493 0 0 -0.75 203.7598 251.9618)",
    fontFamily: "'KozGoPr6N-Regular-83pv-RKSJ-H'",
    fontSize: "8.1415px"
  }, "2"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.7493 0 0 -0.75 206.8799 251.9618)",
    fontFamily: "'KozGoPr6N-Regular-83pv-RKSJ-H'",
    fontSize: "8.1415px"
  }, "5"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.7493 0 0 -0.75 52.6802 273.0819)",
    fontFamily: "'KozGoPr6N-Regular-83pv-RKSJ-H'",
    fontSize: "8.1415px"
  }, "\u30EA"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.7493 0 0 -0.75 61.3198 273.0819)",
    fontFamily: "'KozGoPr6N-Regular-83pv-RKSJ-H'",
    fontSize: "8.1415px"
  }, "\u30FC"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.7493 0 0 -0.75 69.9602 273.0819)",
    fontFamily: "'KozGoPr6N-Regular-83pv-RKSJ-H'",
    fontSize: "8.1415px"
  }, "\u30B9"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.7493 0 0 -0.75 78.5999 273.0819)",
    fontFamily: "'KozGoPr6N-Regular-83pv-RKSJ-H'",
    fontSize: "8.1415px"
  }, "\u671F"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.7493 0 0 -0.75 87.2399 273.0819)",
    fontFamily: "'KozGoPr6N-Regular-83pv-RKSJ-H'",
    fontSize: "8.1415px"
  }, "\u9593"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.7493 0 0 -0.75 95.8799 273.0819)",
    fontFamily: "'KozGoPr6N-Regular-83pv-RKSJ-H'",
    fontSize: "8.1415px"
  }, "\u53C8"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.7493 0 0 -0.75 104.4002 273.0819)",
    fontFamily: "'KozGoPr6N-Regular-83pv-RKSJ-H'",
    fontSize: "8.1415px"
  }, "\u306F"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.7493 0 0 -0.75 113.0398 273.0819)",
    fontFamily: "'KozGoPr6N-Regular-83pv-RKSJ-H'",
    fontSize: "8.1415px"
  }, "\u6539"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.7493 0 0 -0.75 121.5601 273.0819)",
    fontFamily: "'KozGoPr6N-Regular-83pv-RKSJ-H'",
    fontSize: "8.1415px"
  }, "\u5B9A"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.7493 0 0 -0.75 130.1997 273.0819)",
    fontFamily: "'KozGoPr6N-Regular-83pv-RKSJ-H'",
    fontSize: "8.1415px"
  }, "\u30EA"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.7493 0 0 -0.75 138.72 273.0819)",
    fontFamily: "'KozGoPr6N-Regular-83pv-RKSJ-H'",
    fontSize: "8.1415px"
  }, "\u30FC"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.7493 0 0 -0.75 147.36 273.0819)",
    fontFamily: "'KozGoPr6N-Regular-83pv-RKSJ-H'",
    fontSize: "8.1415px"
  }, "\u30B9"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.7493 0 0 -0.75 155.8799 273.0819)",
    fontFamily: "'KozGoPr6N-Regular-83pv-RKSJ-H'",
    fontSize: "8.1415px"
  }, "\u671F"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.7493 0 0 -0.75 164.5199 273.0819)",
    fontFamily: "'KozGoPr6N-Regular-83pv-RKSJ-H'",
    fontSize: "8.1415px"
  }, "\u9593"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.7493 0 0 -0.75 173.0398 273.0819)",
    fontFamily: "'KozGoPr6N-Regular-83pv-RKSJ-H'",
    fontSize: "8.1415px"
  }, "\u306E"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.7493 0 0 -0.75 181.6802 273.0819)",
    fontFamily: "'KozGoPr6N-Regular-83pv-RKSJ-H'",
    fontSize: "8.1415px"
  }, "\u6708"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.7493 0 0 -0.75 190.1998 273.0819)",
    fontFamily: "'KozGoPr6N-Regular-83pv-RKSJ-H'",
    fontSize: "8.1415px"
  }, "\u6570"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.7493 0 0 -0.75 203.7591 273.0819)",
    fontFamily: "'KozGoPr6N-Regular-83pv-RKSJ-H'",
    fontSize: "8.1415px"
  }, "2"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.7493 0 0 -0.75 206.8792 273.0819)",
    fontFamily: "'KozGoPr6N-Regular-83pv-RKSJ-H'",
    fontSize: "8.1415px"
  }, "4"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.7493 0 0 -0.75 216.4798 279.5616)",
    fontFamily: "'KozGoPr6N-Regular-83pv-RKSJ-H'",
    fontSize: "8.1415px"
  }, "("), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.7493 0 0 -0.75 219.5999 279.5616)",
    fontFamily: "'KozGoPr6N-Regular-83pv-RKSJ-H'",
    fontSize: "8.1415px"
  }), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.7493 0 0 -0.75 225.8401 279.5616)",
    fontFamily: "'KozGoPr6N-Regular-83pv-RKSJ-H'",
    fontSize: "8.1415px"
  }), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.7493 0 0 -0.75 232.0797 279.5616)",
    fontFamily: "'KozGoPr6N-Regular-83pv-RKSJ-H'",
    fontSize: "8.1415px"
  }), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.7493 0 0 -0.75 238.3199 279.5616)",
    fontFamily: "'KozGoPr6N-Regular-83pv-RKSJ-H'",
    fontSize: "8.1415px"
  }), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.7493 0 0 -0.75 244.5601 279.5616)",
    fontFamily: "'KozGoPr6N-Regular-83pv-RKSJ-H'",
    fontSize: "8.1415px"
  }), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.7493 0 0 -0.75 250.8004 279.5616)",
    fontFamily: "'KozGoPr6N-Regular-83pv-RKSJ-H'",
    fontSize: "8.1415px"
  }), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.7493 0 0 -0.75 257.0399 279.5616)",
    fontFamily: "'KozGoPr6N-Regular-83pv-RKSJ-H'",
    fontSize: "8.1415px"
  }), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.7493 0 0 -0.75 263.2801 279.5616)",
    fontFamily: "'KozGoPr6N-Regular-83pv-RKSJ-H'",
    fontSize: "8.1415px"
  }), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.7493 0 0 -0.75 269.5196 279.5616)",
    fontFamily: "'KozGoPr6N-Regular-83pv-RKSJ-H'",
    fontSize: "8.1415px"
  }, ")"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.7493 0 0 -0.75 272.6397 279.5616)",
    fontFamily: "'KozGoPr6N-Regular-83pv-RKSJ-H'",
    fontSize: "8.1415px"
  }, "\u6708"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.7493 0 0 -0.75 279.8401 279.5616)",
    fontFamily: "'KozGoPr6N-Regular-83pv-RKSJ-H'",
    fontSize: "8.1415px"
  }, "("), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.7493 0 0 -0.75 282.9603 279.5616)",
    fontFamily: "'KozGoPr6N-Regular-83pv-RKSJ-H'",
    fontSize: "8.1415px"
  }), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.7493 0 0 -0.75 289.1998 279.5616)",
    fontFamily: "'KozGoPr6N-Regular-83pv-RKSJ-H'",
    fontSize: "8.1415px"
  }), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.7493 0 0 -0.75 295.44 279.5616)",
    fontFamily: "'KozGoPr6N-Regular-83pv-RKSJ-H'",
    fontSize: "8.1415px"
  }), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.7493 0 0 -0.75 301.6802 279.5616)",
    fontFamily: "'KozGoPr6N-Regular-83pv-RKSJ-H'",
    fontSize: "8.1415px"
  }), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.7493 0 0 -0.75 307.9198 279.5616)",
    fontFamily: "'KozGoPr6N-Regular-83pv-RKSJ-H'",
    fontSize: "8.1415px"
  }), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.7493 0 0 -0.75 314.16 279.5616)",
    fontFamily: "'KozGoPr6N-Regular-83pv-RKSJ-H'",
    fontSize: "8.1415px"
  }), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.7493 0 0 -0.75 320.4002 279.5616)",
    fontFamily: "'KozGoPr6N-Regular-83pv-RKSJ-H'",
    fontSize: "8.1415px"
  }), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.7493 0 0 -0.75 326.6397 279.5616)",
    fontFamily: "'KozGoPr6N-Regular-83pv-RKSJ-H'",
    fontSize: "8.1415px"
  }), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.7493 0 0 -0.75 332.88 279.5616)",
    fontFamily: "'KozGoPr6N-Regular-83pv-RKSJ-H'",
    fontSize: "8.1415px"
  }, ")"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.7493 0 0 -0.75 336.0001 279.5616)",
    fontFamily: "'KozGoPr6N-Regular-83pv-RKSJ-H'",
    fontSize: "8.1415px"
  }, "\u6708"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.7493 0 0 -0.75 343.1998 279.5616)",
    fontFamily: "'KozGoPr6N-Regular-83pv-RKSJ-H'",
    fontSize: "8.1415px"
  }, "("), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.7493 0 0 -0.75 346.3199 279.5616)",
    fontFamily: "'KozGoPr6N-Regular-83pv-RKSJ-H'",
    fontSize: "8.1415px"
  }), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.7493 0 0 -0.75 352.5602 279.5616)",
    fontFamily: "'KozGoPr6N-Regular-83pv-RKSJ-H'",
    fontSize: "8.1415px"
  }), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.7493 0 0 -0.75 358.8004 279.5616)",
    fontFamily: "'KozGoPr6N-Regular-83pv-RKSJ-H'",
    fontSize: "8.1415px"
  }), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.7493 0 0 -0.75 365.0399 279.5616)",
    fontFamily: "'KozGoPr6N-Regular-83pv-RKSJ-H'",
    fontSize: "8.1415px"
  }), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.7493 0 0 -0.75 371.2801 279.5616)",
    fontFamily: "'KozGoPr6N-Regular-83pv-RKSJ-H'",
    fontSize: "8.1415px"
  }), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.7493 0 0 -0.75 377.5196 279.5616)",
    fontFamily: "'KozGoPr6N-Regular-83pv-RKSJ-H'",
    fontSize: "8.1415px"
  }), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.7493 0 0 -0.75 383.7599 279.5616)",
    fontFamily: "'KozGoPr6N-Regular-83pv-RKSJ-H'",
    fontSize: "8.1415px"
  }), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.7493 0 0 -0.75 390.0001 279.5616)",
    fontFamily: "'KozGoPr6N-Regular-83pv-RKSJ-H'",
    fontSize: "8.1415px"
  }), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.7493 0 0 -0.75 396.2403 279.5616)",
    fontFamily: "'KozGoPr6N-Regular-83pv-RKSJ-H'",
    fontSize: "8.1415px"
  }, ")"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.7493 0 0 -0.75 399.3604 279.5616)",
    fontFamily: "'KozGoPr6N-Regular-83pv-RKSJ-H'",
    fontSize: "8.1415px"
  }, "\u6708"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.7493 0 0 -0.75 406.5602 279.5616)",
    fontFamily: "'KozGoPr6N-Regular-83pv-RKSJ-H'",
    fontSize: "8.1415px"
  }, "("), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.7493 0 0 -0.75 409.6803 279.5616)",
    fontFamily: "'KozGoPr6N-Regular-83pv-RKSJ-H'",
    fontSize: "8.1415px"
  }), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.7493 0 0 -0.75 415.9198 279.5616)",
    fontFamily: "'KozGoPr6N-Regular-83pv-RKSJ-H'",
    fontSize: "8.1415px"
  }), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.7493 0 0 -0.75 422.16 279.5616)",
    fontFamily: "'KozGoPr6N-Regular-83pv-RKSJ-H'",
    fontSize: "8.1415px"
  }), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.7493 0 0 -0.75 428.4003 279.5616)",
    fontFamily: "'KozGoPr6N-Regular-83pv-RKSJ-H'",
    fontSize: "8.1415px"
  }), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.7493 0 0 -0.75 434.6398 279.5616)",
    fontFamily: "'KozGoPr6N-Regular-83pv-RKSJ-H'",
    fontSize: "8.1415px"
  }), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.7493 0 0 -0.75 440.88 279.5616)",
    fontFamily: "'KozGoPr6N-Regular-83pv-RKSJ-H'",
    fontSize: "8.1415px"
  }), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.7493 0 0 -0.75 447.1202 279.5616)",
    fontFamily: "'KozGoPr6N-Regular-83pv-RKSJ-H'",
    fontSize: "8.1415px"
  }), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.7493 0 0 -0.75 453.3597 279.5616)",
    fontFamily: "'KozGoPr6N-Regular-83pv-RKSJ-H'",
    fontSize: "8.1415px"
  }), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.7493 0 0 -0.75 459.6 279.5616)",
    fontFamily: "'KozGoPr6N-Regular-83pv-RKSJ-H'",
    fontSize: "8.1415px"
  }, ")"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.7493 0 0 -0.75 462.7201 279.5616)",
    fontFamily: "'KozGoPr6N-Regular-83pv-RKSJ-H'",
    fontSize: "8.1415px"
  }, "\u6708"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.7493 0 0 -0.75 66.1201 298.8822)",
    fontFamily: "'KozGoPr6N-Regular-83pv-RKSJ-H'",
    fontSize: "8.1415px"
  }, "\u5DEE"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.7493 0 0 -0.75 83.8792 298.8822)",
    fontFamily: "'KozGoPr6N-Regular-83pv-RKSJ-H'",
    fontSize: "8.1415px"
  }, "\u5F15"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.7493 0 0 -0.75 101.6382 298.8822)",
    fontFamily: "'KozGoPr6N-Regular-83pv-RKSJ-H'",
    fontSize: "8.1415px"
  }, "\u5E33"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.7493 0 0 -0.75 119.3972 298.8822)",
    fontFamily: "'KozGoPr6N-Regular-83pv-RKSJ-H'",
    fontSize: "8.1415px"
  }, "\u7C3F"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.7493 0 0 -0.75 137.1559 298.8822)",
    fontFamily: "'KozGoPr6N-Regular-83pv-RKSJ-H'",
    fontSize: "8.1415px"
  }, "\u8A18"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.7493 0 0 -0.75 154.7959 298.8822)",
    fontFamily: "'KozGoPr6N-Regular-83pv-RKSJ-H'",
    fontSize: "8.1415px"
  }, "\u8F09"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.7493 0 0 -0.75 172.555 298.8822)",
    fontFamily: "'KozGoPr6N-Regular-83pv-RKSJ-H'",
    fontSize: "8.1415px"
  }, "\u91D1"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.7493 0 0 -0.75 190.195 298.8822)",
    fontFamily: "'KozGoPr6N-Regular-83pv-RKSJ-H'",
    fontSize: "8.1415px"
  }, "\u984D"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.7493 0 0 -0.75 105.5999 289.5219)",
    fontFamily: "'KozGoPr6N-Regular-83pv-RKSJ-H'",
    fontSize: "8.1415px"
  }, "("), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.7493 0 0 -0.75 108.72 289.5219)",
    fontFamily: "'KozGoPr6N-Regular-83pv-RKSJ-H'",
    fontSize: "8.1415px"
  }, "2"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.7493 0 0 -0.75 111.8401 289.5219)",
    fontFamily: "'KozGoPr6N-Regular-83pv-RKSJ-H'",
    fontSize: "8.1415px"
  }, "0"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.7493 0 0 -0.75 114.9602 289.5219)",
    fontFamily: "'KozGoPr6N-Regular-83pv-RKSJ-H'",
    fontSize: "8.1415px"
  }, ")"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.7493 0 0 -0.75 118.44 289.5219)",
    fontFamily: "'KozGoPr6N-Regular-83pv-RKSJ-H'",
    fontSize: "8.1415px"
  }, "\uFF0D"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.7493 0 0 -0.75 125.0398 289.5219)",
    fontFamily: "'KozGoPr6N-Regular-83pv-RKSJ-H'",
    fontSize: "8.1415px"
  }, "("), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.7493 0 0 -0.75 128.1599 289.5219)",
    fontFamily: "'KozGoPr6N-Regular-83pv-RKSJ-H'",
    fontSize: "8.1415px"
  }, "2"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.7493 0 0 -0.75 131.2801 289.5219)",
    fontFamily: "'KozGoPr6N-Regular-83pv-RKSJ-H'",
    fontSize: "8.1415px"
  }, "1"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.7493 0 0 -0.75 134.4002 289.5219)",
    fontFamily: "'KozGoPr6N-Regular-83pv-RKSJ-H'",
    fontSize: "8.1415px"
  }, ")"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.7493 0 0 -0.75 137.8799 289.5219)",
    fontFamily: "'KozGoPr6N-Regular-83pv-RKSJ-H'",
    fontSize: "8.1415px"
  }, "\uFF0D"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.7493 0 0 -0.75 144.4798 289.5219)",
    fontFamily: "'KozGoPr6N-Regular-83pv-RKSJ-H'",
    fontSize: "8.1415px"
  }, "("), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.7493 0 0 -0.75 147.5999 289.5219)",
    fontFamily: "'KozGoPr6N-Regular-83pv-RKSJ-H'",
    fontSize: "8.1415px"
  }, "2"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.7493 0 0 -0.75 150.72 289.5219)",
    fontFamily: "'KozGoPr6N-Regular-83pv-RKSJ-H'",
    fontSize: "8.1415px"
  }, "2"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.7493 0 0 -0.75 153.8401 289.5219)",
    fontFamily: "'KozGoPr6N-Regular-83pv-RKSJ-H'",
    fontSize: "8.1415px"
  }, ")"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.7493 0 0 -0.75 203.7598 294.202)",
    fontFamily: "'KozGoPr6N-Regular-83pv-RKSJ-H'",
    fontSize: "8.1415px"
  }, "2"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.7493 0 0 -0.75 206.8799 294.202)",
    fontFamily: "'KozGoPr6N-Regular-83pv-RKSJ-H'",
    fontSize: "8.1415px"
  }, "3"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.7493 0 0 -0.75 216.8401 300.6818)",
    fontFamily: "'KozGoPr6N-Regular-83pv-RKSJ-H'",
    fontSize: "8.1415px"
  }, "\u5916"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.7493 0 0 -0.75 223.08 300.6818)",
    fontFamily: "'KozGoPr6N-Regular-83pv-RKSJ-H'",
    fontSize: "8.1415px"
  }, "\u25B3"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.7493 0 0 -0.75 280.1998 300.6818)",
    fontFamily: "'KozGoPr6N-Regular-83pv-RKSJ-H'",
    fontSize: "8.1415px"
  }, "\u5916"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.7493 0 0 -0.75 286.44 300.6818)",
    fontFamily: "'KozGoPr6N-Regular-83pv-RKSJ-H'",
    fontSize: "8.1415px"
  }, "\u25B3"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.7493 0 0 -0.75 343.5602 300.6818)",
    fontFamily: "'KozGoPr6N-Regular-83pv-RKSJ-H'",
    fontSize: "8.1415px"
  }, "\u5916"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.7493 0 0 -0.75 349.8004 300.6818)",
    fontFamily: "'KozGoPr6N-Regular-83pv-RKSJ-H'",
    fontSize: "8.1415px"
  }, "\u25B3"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.7493 0 0 -0.75 406.9198 300.6818)",
    fontFamily: "'KozGoPr6N-Regular-83pv-RKSJ-H'",
    fontSize: "8.1415px"
  }, "\u5916"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.7493 0 0 -0.75 413.16 300.6818)",
    fontFamily: "'KozGoPr6N-Regular-83pv-RKSJ-H'",
    fontSize: "8.1415px"
  }, "\u25B3"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.7493 0 0 -0.75 470.2802 300.6818)",
    fontFamily: "'KozGoPr6N-Regular-83pv-RKSJ-H'",
    fontSize: "8.1415px"
  }, "\u5916"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.7493 0 0 -0.75 476.5197 300.6818)",
    fontFamily: "'KozGoPr6N-Regular-83pv-RKSJ-H'",
    fontSize: "8.1415px"
  }, "\u25B3"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.7493 0 0 -0.75 66.1201 315.3222)",
    fontFamily: "'KozGoPr6N-Regular-83pv-RKSJ-H'",
    fontSize: "8.1415px"
  }, "\u7A4D"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.7493 0 0 -0.75 81.5999 315.3222)",
    fontFamily: "'KozGoPr6N-Regular-83pv-RKSJ-H'",
    fontSize: "8.1415px"
  }, "\u7ACB"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.7493 0 0 -0.75 97.08 315.3222)",
    fontFamily: "'KozGoPr6N-Regular-83pv-RKSJ-H'",
    fontSize: "8.1415px"
  }, "\u91D1"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.7493 0 0 -0.75 112.5601 315.3222)",
    fontFamily: "'KozGoPr6N-Regular-83pv-RKSJ-H'",
    fontSize: "8.1415px"
  }, "\u306E"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.7493 0 0 -0.75 128.0398 315.3222)",
    fontFamily: "'KozGoPr6N-Regular-83pv-RKSJ-H'",
    fontSize: "8.1415px"
  }, "\u671F"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.7493 0 0 -0.75 143.64 315.3222)",
    fontFamily: "'KozGoPr6N-Regular-83pv-RKSJ-H'",
    fontSize: "8.1415px"
  }, "\u4E2D"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.7493 0 0 -0.75 159.1202 315.3222)",
    fontFamily: "'KozGoPr6N-Regular-83pv-RKSJ-H'",
    fontSize: "8.1415px"
  }, "\u53D6"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.7493 0 0 -0.75 174.72 315.3222)",
    fontFamily: "'KozGoPr6N-Regular-83pv-RKSJ-H'",
    fontSize: "8.1415px"
  }, "\u5D29"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.7493 0 0 -0.75 190.1998 315.3222)",
    fontFamily: "'KozGoPr6N-Regular-83pv-RKSJ-H'",
    fontSize: "8.1415px"
  }, "\u984D"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.7493 0 0 -0.75 203.7591 315.3222)",
    fontFamily: "'KozGoPr6N-Regular-83pv-RKSJ-H'",
    fontSize: "8.1415px"
  }, "2"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.7493 0 0 -0.75 206.8792 315.3222)",
    fontFamily: "'KozGoPr6N-Regular-83pv-RKSJ-H'",
    fontSize: "8.1415px"
  }, "2"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.7493 0 0 -0.75 66.1201 336.4423)",
    fontFamily: "'KozGoPr6N-Regular-83pv-RKSJ-H'",
    fontSize: "8.1415px"
  }, "\u671F"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.7493 0 0 -0.75 79.9201 336.4423)",
    fontFamily: "'KozGoPr6N-Regular-83pv-RKSJ-H'",
    fontSize: "8.1415px"
  }, "\u672B"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.7493 0 0 -0.75 93.72 336.4423)",
    fontFamily: "'KozGoPr6N-Regular-83pv-RKSJ-H'",
    fontSize: "8.1415px"
  }, "\u73FE"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.7493 0 0 -0.75 107.5199 336.4423)",
    fontFamily: "'KozGoPr6N-Regular-83pv-RKSJ-H'",
    fontSize: "8.1415px"
  }, "\u5728"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.7493 0 0 -0.75 121.3199 336.4423)",
    fontFamily: "'KozGoPr6N-Regular-83pv-RKSJ-H'",
    fontSize: "8.1415px"
  }, "\u306E"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.7493 0 0 -0.75 135.1201 336.4423)",
    fontFamily: "'KozGoPr6N-Regular-83pv-RKSJ-H'",
    fontSize: "8.1415px"
  }, "\u7A4D"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.7493 0 0 -0.75 148.9201 336.4423)",
    fontFamily: "'KozGoPr6N-Regular-83pv-RKSJ-H'",
    fontSize: "8.1415px"
  }, "\u7ACB"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.7493 0 0 -0.75 162.72 336.4423)",
    fontFamily: "'KozGoPr6N-Regular-83pv-RKSJ-H'",
    fontSize: "8.1415px"
  }, "\u91D1"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.7493 0 0 -0.75 176.5199 336.4423)",
    fontFamily: "'KozGoPr6N-Regular-83pv-RKSJ-H'",
    fontSize: "8.1415px"
  }, "\u306E"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.7493 0 0 -0.75 190.199 336.4423)",
    fontFamily: "'KozGoPr6N-Regular-83pv-RKSJ-H'",
    fontSize: "8.1415px"
  }, "\u984D"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.7493 0 0 -0.75 203.758 336.4423)",
    fontFamily: "'KozGoPr6N-Regular-83pv-RKSJ-H'",
    fontSize: "8.1415px"
  }, "2"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.7493 0 0 -0.75 206.8777 336.4423)",
    fontFamily: "'KozGoPr6N-Regular-83pv-RKSJ-H'",
    fontSize: "8.1415px"
  }, "1"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.7493 0 0 -0.75 55.1997 355.5219)",
    fontFamily: "'KozGoPr6N-Regular-83pv-RKSJ-H'",
    fontSize: "8.1415px"
  }, "\u5E33"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.7493 0 0 -0.75 55.1997 343.7724)",
    fontFamily: "'KozGoPr6N-Regular-83pv-RKSJ-H'",
    fontSize: "8.1415px"
  }, "\u7C3F"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.7493 0 0 -0.75 55.1997 331.902)",
    fontFamily: "'KozGoPr6N-Regular-83pv-RKSJ-H'",
    fontSize: "8.1415px"
  }, "\u8A18"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.7493 0 0 -0.75 55.1997 320.0324)",
    fontFamily: "'KozGoPr6N-Regular-83pv-RKSJ-H'",
    fontSize: "8.1415px"
  }, "\u8F09"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.7493 0 0 -0.75 55.1997 308.1628)",
    fontFamily: "'KozGoPr6N-Regular-83pv-RKSJ-H'",
    fontSize: "8.1415px"
  }, "\u91D1"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.7493 0 0 -0.75 55.1997 296.2931)",
    fontFamily: "'KozGoPr6N-Regular-83pv-RKSJ-H'",
    fontSize: "8.1415px"
  }, "\u984D"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.7493 0 0 -0.75 66 357.6818)",
    fontFamily: "'KozGoPr6N-Regular-83pv-RKSJ-H'",
    fontSize: "7.6076px"
  }, "\u511F"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.7493 0 0 -0.75 72 357.6818)",
    fontFamily: "'KozGoPr6N-Regular-83pv-RKSJ-H'",
    fontSize: "7.6076px"
  }, "\u5374"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.7493 0 0 -0.75 78 357.6818)",
    fontFamily: "'KozGoPr6N-Regular-83pv-RKSJ-H'",
    fontSize: "7.6076px"
  }, "\u984D"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.7493 0 0 -0.75 83.8799 357.6818)",
    fontFamily: "'KozGoPr6N-Regular-83pv-RKSJ-H'",
    fontSize: "7.6076px"
  }, "\u8A08"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.7493 0 0 -0.75 89.8799 357.6818)",
    fontFamily: "'KozGoPr6N-Regular-83pv-RKSJ-H'",
    fontSize: "7.6076px"
  }, "\u7B97"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.7493 0 0 -0.75 95.7598 357.6818)",
    fontFamily: "'KozGoPr6N-Regular-83pv-RKSJ-H'",
    fontSize: "7.6076px"
  }, "\u306E"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.7493 0 0 -0.75 101.7598 357.6818)",
    fontFamily: "'KozGoPr6N-Regular-83pv-RKSJ-H'",
    fontSize: "7.6076px"
  }, "\u5BFE"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.7493 0 0 -0.75 107.64 357.6818)",
    fontFamily: "'KozGoPr6N-Regular-83pv-RKSJ-H'",
    fontSize: "7.6076px"
  }, "\u8C61"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.7493 0 0 -0.75 113.64 357.6818)",
    fontFamily: "'KozGoPr6N-Regular-83pv-RKSJ-H'",
    fontSize: "7.6076px"
  }, "\u3068"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.7493 0 0 -0.75 119.5199 357.6818)",
    fontFamily: "'KozGoPr6N-Regular-83pv-RKSJ-H'",
    fontSize: "7.6076px"
  }, "\u306A"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.7493 0 0 -0.75 125.5199 357.6818)",
    fontFamily: "'KozGoPr6N-Regular-83pv-RKSJ-H'",
    fontSize: "7.6076px"
  }, "\u308B"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.7493 0 0 -0.75 131.4002 357.6818)",
    fontFamily: "'KozGoPr6N-Regular-83pv-RKSJ-H'",
    fontSize: "7.6076px"
  }, "\u671F"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.7493 0 0 -0.75 137.4002 357.6818)",
    fontFamily: "'KozGoPr6N-Regular-83pv-RKSJ-H'",
    fontSize: "7.6076px"
  }, "\u672B"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.7493 0 0 -0.75 143.2801 357.6818)",
    fontFamily: "'KozGoPr6N-Regular-83pv-RKSJ-H'",
    fontSize: "7.6076px"
  }, "\u73FE"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.7493 0 0 -0.75 149.2801 357.6818)",
    fontFamily: "'KozGoPr6N-Regular-83pv-RKSJ-H'",
    fontSize: "7.6076px"
  }, "\u5728"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.7493 0 0 -0.75 155.16 357.6818)",
    fontFamily: "'KozGoPr6N-Regular-83pv-RKSJ-H'",
    fontSize: "7.6076px"
  }, "\u306E"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.7493 0 0 -0.75 161.16 357.6818)",
    fontFamily: "'KozGoPr6N-Regular-83pv-RKSJ-H'",
    fontSize: "7.6076px"
  }, "\u5E33"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.7493 0 0 -0.75 167.0398 357.6818)",
    fontFamily: "'KozGoPr6N-Regular-83pv-RKSJ-H'",
    fontSize: "7.6076px"
  }, "\u7C3F"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.7493 0 0 -0.75 173.0398 357.6818)",
    fontFamily: "'KozGoPr6N-Regular-83pv-RKSJ-H'",
    fontSize: "7.6076px"
  }, "\u8A18"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.7493 0 0 -0.75 178.9201 357.6818)",
    fontFamily: "'KozGoPr6N-Regular-83pv-RKSJ-H'",
    fontSize: "7.6076px"
  }, "\u8F09"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.7493 0 0 -0.75 184.9197 357.6818)",
    fontFamily: "'KozGoPr6N-Regular-83pv-RKSJ-H'",
    fontSize: "7.6076px"
  }, "\u91D1"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.7493 0 0 -0.75 190.8 357.6818)",
    fontFamily: "'KozGoPr6N-Regular-83pv-RKSJ-H'",
    fontSize: "7.6076px"
  }, "\u984D"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.7493 0 0 -0.75 203.7598 357.5617)",
    fontFamily: "'KozGoPr6N-Regular-83pv-RKSJ-H'",
    fontSize: "8.1415px"
  }, "2"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.7493 0 0 -0.75 206.8799 357.5617)",
    fontFamily: "'KozGoPr6N-Regular-83pv-RKSJ-H'",
    fontSize: "8.1415px"
  }, "0"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.7493 0 0 -0.75 406.9198 427.4025)",
    fontFamily: "'KozGoPr6N-Regular-83pv-RKSJ-H'",
    fontSize: "8.1415px"
  }, "\u5916"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.7493 0 0 -0.75 470.2794 427.4025)",
    fontFamily: "'KozGoPr6N-Regular-83pv-RKSJ-H'",
    fontSize: "8.1415px"
  }, "\u5916"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.7493 0 0 -0.75 77.64 399.8019)",
    fontFamily: "'KozGoPr6N-Regular-83pv-RKSJ-H'",
    fontSize: "8.1415px"
  }, "\u6B8B"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.7493 0 0 -0.75 105.8401 399.8019)",
    fontFamily: "'KozGoPr6N-Regular-83pv-RKSJ-H'",
    fontSize: "8.1415px"
  }, "\u4FA1"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.7493 0 0 -0.75 133.919 399.8019)",
    fontFamily: "'KozGoPr6N-Regular-83pv-RKSJ-H'",
    fontSize: "8.1415px"
  }, "\u4FDD"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.7493 0 0 -0.75 162.1191 399.8019)",
    fontFamily: "'KozGoPr6N-Regular-83pv-RKSJ-H'",
    fontSize: "8.1415px"
  }, "\u8A3C"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.7493 0 0 -0.75 190.1979 399.8019)",
    fontFamily: "'KozGoPr6N-Regular-83pv-RKSJ-H'",
    fontSize: "8.1415px"
  }, "\u984D"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.7493 0 0 -0.75 203.7569 399.8019)",
    fontFamily: "'KozGoPr6N-Regular-83pv-RKSJ-H'",
    fontSize: "8.1415px"
  }, "1"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.7493 0 0 -0.75 206.877 399.8019)",
    fontFamily: "'KozGoPr6N-Regular-83pv-RKSJ-H'",
    fontSize: "8.1415px"
  }, "8"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.7493 0 0 -0.75 67.6802 425.1217)",
    fontFamily: "'KozGoPr6N-Regular-83pv-RKSJ-H'",
    fontSize: "8.1415px"
  }, "\u30EA"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0 -1 1 0 70 420.6845)",
    fontFamily: "'KozGoPr6N-Regular-83pv-RKSJ-H'",
    fontSize: "8.1333px",
    glyphOrientationVertical: 0,
    writingMode: "tb"
  }, "|"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.7493 0 0 -0.75 67.6802 410.7223)",
    fontFamily: "'KozGoPr6N-Regular-83pv-RKSJ-H'",
    fontSize: "8.1415px"
  }, "\u30B9"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.7493 0 0 -0.75 67.6802 403.5277)",
    fontFamily: "'KozGoPr6N-Regular-83pv-RKSJ-H'",
    fontSize: "8.1415px"
  }, "\u671F"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.7493 0 0 -0.75 67.6802 396.2145)",
    fontFamily: "'KozGoPr6N-Regular-83pv-RKSJ-H'",
    fontSize: "8.1415px"
  }, "\u9593"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.7493 0 0 -0.75 67.6802 389.0207)",
    fontFamily: "'KozGoPr6N-Regular-83pv-RKSJ-H'",
    fontSize: "8.1415px"
  }, "\u5B9A"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.7493 0 0 -0.75 67.6802 381.8261)",
    fontFamily: "'KozGoPr6N-Regular-83pv-RKSJ-H'",
    fontSize: "8.1415px"
  }, "\u984D"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.7493 0 0 -0.75 67.6802 374.6322)",
    fontFamily: "'KozGoPr6N-Regular-83pv-RKSJ-H'",
    fontSize: "8.1415px"
  }, "\u6CD5"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.7493 0 0 -0.75 77.64 420.922)",
    fontFamily: "'KozGoPr6N-Regular-83pv-RKSJ-H'",
    fontSize: "8.1415px"
  }, "\u53D6"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.7493 0 0 -0.75 115.1997 420.922)",
    fontFamily: "'KozGoPr6N-Regular-83pv-RKSJ-H'",
    fontSize: "8.1415px"
  }, "\u5F97"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.7493 0 0 -0.75 152.7598 420.922)",
    fontFamily: "'KozGoPr6N-Regular-83pv-RKSJ-H'",
    fontSize: "8.1415px"
  }, "\u4FA1"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.7493 0 0 -0.75 190.1998 420.922)",
    fontFamily: "'KozGoPr6N-Regular-83pv-RKSJ-H'",
    fontSize: "8.1415px"
  }, "\u984D"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.7493 0 0 -0.75 203.7591 420.922)",
    fontFamily: "'KozGoPr6N-Regular-83pv-RKSJ-H'",
    fontSize: "8.1415px"
  }, "1"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.7493 0 0 -0.75 206.8792 420.922)",
    fontFamily: "'KozGoPr6N-Regular-83pv-RKSJ-H'",
    fontSize: "8.1415px"
  }, "7"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.7493 0 0 -0.75 216.8401 427.4025)",
    fontFamily: "'KozGoPr6N-Regular-83pv-RKSJ-H'",
    fontSize: "8.1415px"
  }, "\u5916"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.7493 0 0 -0.75 280.199 427.4025)",
    fontFamily: "'KozGoPr6N-Regular-83pv-RKSJ-H'",
    fontSize: "8.1415px"
  }, "\u5916"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.7493 0 0 -0.75 343.558 427.4025)",
    fontFamily: "'KozGoPr6N-Regular-83pv-RKSJ-H'",
    fontSize: "8.1415px"
  }, "\u5916"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.7493 0 0 -0.75 77.64 383.362)",
    fontFamily: "'KozGoPr6N-Regular-83pv-RKSJ-H'",
    fontSize: "8.1415px"
  }, "\u511F"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.7493 0 0 -0.75 87 383.362)",
    fontFamily: "'KozGoPr6N-Regular-83pv-RKSJ-H'",
    fontSize: "8.1415px"
  }, "\u5374"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.7493 0 0 -0.75 96.36 383.362)",
    fontFamily: "'KozGoPr6N-Regular-83pv-RKSJ-H'",
    fontSize: "8.1415px"
  }, "\u984D"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.7493 0 0 -0.75 105.72 383.362)",
    fontFamily: "'KozGoPr6N-Regular-83pv-RKSJ-H'",
    fontSize: "8.1415px"
  }, "\u8A08"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.7493 0 0 -0.75 115.08 383.362)",
    fontFamily: "'KozGoPr6N-Regular-83pv-RKSJ-H'",
    fontSize: "8.1415px"
  }, "\u7B97"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.7493 0 0 -0.75 124.44 383.362)",
    fontFamily: "'KozGoPr6N-Regular-83pv-RKSJ-H'",
    fontSize: "8.1415px"
  }, "\u306E"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.7493 0 0 -0.75 133.8 383.362)",
    fontFamily: "'KozGoPr6N-Regular-83pv-RKSJ-H'",
    fontSize: "8.1415px"
  }, "\u57FA"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.7493 0 0 -0.75 143.1599 383.362)",
    fontFamily: "'KozGoPr6N-Regular-83pv-RKSJ-H'",
    fontSize: "8.1415px"
  }, "\u790E"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.7493 0 0 -0.75 152.5199 383.362)",
    fontFamily: "'KozGoPr6N-Regular-83pv-RKSJ-H'",
    fontSize: "8.1415px"
  }, "\u3068"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.7493 0 0 -0.75 162 383.362)",
    fontFamily: "'KozGoPr6N-Regular-83pv-RKSJ-H'",
    fontSize: "8.1415px"
  }, "\u306A"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.7493 0 0 -0.75 171.36 383.362)",
    fontFamily: "'KozGoPr6N-Regular-83pv-RKSJ-H'",
    fontSize: "8.1415px"
  }, "\u308B"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.7493 0 0 -0.75 180.8401 383.362)",
    fontFamily: "'KozGoPr6N-Regular-83pv-RKSJ-H'",
    fontSize: "8.1415px"
  }, "\u91D1"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.7493 0 0 -0.75 190.1998 383.362)",
    fontFamily: "'KozGoPr6N-Regular-83pv-RKSJ-H'",
    fontSize: "8.1415px"
  }, "\u984D"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.7493 0 0 -0.75 120.8401 374.0016)",
    fontFamily: "'KozGoPr6N-Regular-83pv-RKSJ-H'",
    fontSize: "8.1415px"
  }, "("), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.7493 0 0 -0.75 123.9602 374.0016)",
    fontFamily: "'KozGoPr6N-Regular-83pv-RKSJ-H'",
    fontSize: "8.1415px"
  }, "1"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.7493 0 0 -0.75 127.08 374.0016)",
    fontFamily: "'KozGoPr6N-Regular-83pv-RKSJ-H'",
    fontSize: "8.1415px"
  }, "7"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.7493 0 0 -0.75 130.1997 374.0016)",
    fontFamily: "'KozGoPr6N-Regular-83pv-RKSJ-H'",
    fontSize: "8.1415px"
  }, ")"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.7493 0 0 -0.75 133.8 374.0016)",
    fontFamily: "'KozGoPr6N-Regular-83pv-RKSJ-H'",
    fontSize: "8.1415px"
  }, "\uFF0D"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.7493 0 0 -0.75 140.5188 374.0016)",
    fontFamily: "'KozGoPr6N-Regular-83pv-RKSJ-H'",
    fontSize: "8.1415px"
  }, "("), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.7493 0 0 -0.75 143.6389 374.0016)",
    fontFamily: "'KozGoPr6N-Regular-83pv-RKSJ-H'",
    fontSize: "8.1415px"
  }, "1"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.7493 0 0 -0.75 146.7591 374.0016)",
    fontFamily: "'KozGoPr6N-Regular-83pv-RKSJ-H'",
    fontSize: "8.1415px"
  }, "8"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.7493 0 0 -0.75 149.8792 374.0016)",
    fontFamily: "'KozGoPr6N-Regular-83pv-RKSJ-H'",
    fontSize: "8.1415px"
  }, ")"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.7493 0 0 -0.75 203.7598 378.6818)",
    fontFamily: "'KozGoPr6N-Regular-83pv-RKSJ-H'",
    fontSize: "8.1415px"
  }, "1"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.7493 0 0 -0.75 206.8799 378.6818)",
    fontFamily: "'KozGoPr6N-Regular-83pv-RKSJ-H'",
    fontSize: "8.1415px"
  }, "9"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.7493 0 0 -0.75 77.64 446.7224)",
    fontFamily: "'KozGoPr6N-Regular-83pv-RKSJ-H'",
    fontSize: "8.1415px"
  }, "\u511F"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.7493 0 0 -0.75 87 446.7224)",
    fontFamily: "'KozGoPr6N-Regular-83pv-RKSJ-H'",
    fontSize: "8.1415px"
  }, "\u5374"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.7493 0 0 -0.75 96.36 446.7224)",
    fontFamily: "'KozGoPr6N-Regular-83pv-RKSJ-H'",
    fontSize: "8.1415px"
  }, "\u984D"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.7493 0 0 -0.75 105.72 446.7224)",
    fontFamily: "'KozGoPr6N-Regular-83pv-RKSJ-H'",
    fontSize: "8.1415px"
  }, "\u8A08"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.7493 0 0 -0.75 115.08 446.7224)",
    fontFamily: "'KozGoPr6N-Regular-83pv-RKSJ-H'",
    fontSize: "8.1415px"
  }, "\u7B97"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.7493 0 0 -0.75 124.44 446.7224)",
    fontFamily: "'KozGoPr6N-Regular-83pv-RKSJ-H'",
    fontSize: "8.1415px"
  }, "\u306E"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.7493 0 0 -0.75 133.8 446.7224)",
    fontFamily: "'KozGoPr6N-Regular-83pv-RKSJ-H'",
    fontSize: "8.1415px"
  }, "\u57FA"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.7493 0 0 -0.75 143.1599 446.7224)",
    fontFamily: "'KozGoPr6N-Regular-83pv-RKSJ-H'",
    fontSize: "8.1415px"
  }, "\u790E"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.7493 0 0 -0.75 152.5199 446.7224)",
    fontFamily: "'KozGoPr6N-Regular-83pv-RKSJ-H'",
    fontSize: "8.1415px"
  }, "\u3068"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.7493 0 0 -0.75 162 446.7224)",
    fontFamily: "'KozGoPr6N-Regular-83pv-RKSJ-H'",
    fontSize: "8.1415px"
  }, "\u306A"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.7493 0 0 -0.75 171.36 446.7224)",
    fontFamily: "'KozGoPr6N-Regular-83pv-RKSJ-H'",
    fontSize: "8.1415px"
  }, "\u308B"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.7493 0 0 -0.75 180.8401 446.7224)",
    fontFamily: "'KozGoPr6N-Regular-83pv-RKSJ-H'",
    fontSize: "8.1415px"
  }, "\u91D1"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.7493 0 0 -0.75 190.1998 446.7224)",
    fontFamily: "'KozGoPr6N-Regular-83pv-RKSJ-H'",
    fontSize: "8.1415px"
  }, "\u984D"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.7493 0 0 -0.75 120.8401 437.362)",
    fontFamily: "'KozGoPr6N-Regular-83pv-RKSJ-H'",
    fontSize: "8.1415px"
  }, "("), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.7493 0 0 -0.75 123.9602 437.362)",
    fontFamily: "'KozGoPr6N-Regular-83pv-RKSJ-H'",
    fontSize: "8.1415px"
  }, "1"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.7493 0 0 -0.75 127.08 437.362)",
    fontFamily: "'KozGoPr6N-Regular-83pv-RKSJ-H'",
    fontSize: "8.1415px"
  }, "4"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.7493 0 0 -0.75 130.1997 437.362)",
    fontFamily: "'KozGoPr6N-Regular-83pv-RKSJ-H'",
    fontSize: "8.1415px"
  }, ")"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.7493 0 0 -0.75 133.8 437.362)",
    fontFamily: "'KozGoPr6N-Regular-83pv-RKSJ-H'",
    fontSize: "8.1415px"
  }, "\uFF0D"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.7493 0 0 -0.75 140.5188 437.362)",
    fontFamily: "'KozGoPr6N-Regular-83pv-RKSJ-H'",
    fontSize: "8.1415px"
  }, "("), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.7493 0 0 -0.75 143.6389 437.362)",
    fontFamily: "'KozGoPr6N-Regular-83pv-RKSJ-H'",
    fontSize: "8.1415px"
  }, "1"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.7493 0 0 -0.75 146.7591 437.362)",
    fontFamily: "'KozGoPr6N-Regular-83pv-RKSJ-H'",
    fontSize: "8.1415px"
  }, "5"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.7493 0 0 -0.75 149.8792 437.362)",
    fontFamily: "'KozGoPr6N-Regular-83pv-RKSJ-H'",
    fontSize: "8.1415px"
  }, ")"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.7493 0 0 -0.75 203.7598 442.0422)",
    fontFamily: "'KozGoPr6N-Regular-83pv-RKSJ-H'",
    fontSize: "8.1415px"
  }, "1"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.7493 0 0 -0.75 206.8799 442.0422)",
    fontFamily: "'KozGoPr6N-Regular-83pv-RKSJ-H'",
    fontSize: "8.1415px"
  }, "6"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.7493 0 0 -0.75 77.64 463.1623)",
    fontFamily: "'KozGoPr6N-Regular-83pv-RKSJ-H'",
    fontSize: "8.1415px"
  }, "\u6B8B"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.7493 0 0 -0.75 105.8401 463.1623)",
    fontFamily: "'KozGoPr6N-Regular-83pv-RKSJ-H'",
    fontSize: "8.1415px"
  }, "\u4FA1"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.7493 0 0 -0.75 133.919 463.1623)",
    fontFamily: "'KozGoPr6N-Regular-83pv-RKSJ-H'",
    fontSize: "8.1415px"
  }, "\u4FDD"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.7493 0 0 -0.75 162.1191 463.1623)",
    fontFamily: "'KozGoPr6N-Regular-83pv-RKSJ-H'",
    fontSize: "8.1415px"
  }, "\u8A3C"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.7493 0 0 -0.75 190.1979 463.1623)",
    fontFamily: "'KozGoPr6N-Regular-83pv-RKSJ-H'",
    fontSize: "8.1415px"
  }, "\u984D"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.7493 0 0 -0.75 203.7569 463.1623)",
    fontFamily: "'KozGoPr6N-Regular-83pv-RKSJ-H'",
    fontSize: "8.1415px"
  }, "1"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.7493 0 0 -0.75 206.877 463.1623)",
    fontFamily: "'KozGoPr6N-Regular-83pv-RKSJ-H'",
    fontSize: "8.1415px"
  }, "5"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.7493 0 0 -0.75 77.64 488.9619)",
    fontFamily: "'KozGoPr6N-Regular-83pv-RKSJ-H'",
    fontSize: "8.1415px"
  }, "\u5DEE"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.7493 0 0 -0.75 100.1997 488.9619)",
    fontFamily: "'KozGoPr6N-Regular-83pv-RKSJ-H'",
    fontSize: "8.1415px"
  }, "\u5F15"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.7493 0 0 -0.75 122.7598 488.9619)",
    fontFamily: "'KozGoPr6N-Regular-83pv-RKSJ-H'",
    fontSize: "8.1415px"
  }, "\u53D6"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.7493 0 0 -0.75 145.1997 488.9619)",
    fontFamily: "'KozGoPr6N-Regular-83pv-RKSJ-H'",
    fontSize: "8.1415px"
  }, "\u5F97"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.7493 0 0 -0.75 167.7598 488.9619)",
    fontFamily: "'KozGoPr6N-Regular-83pv-RKSJ-H'",
    fontSize: "8.1415px"
  }, "\u4FA1"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.7493 0 0 -0.75 190.1998 488.9619)",
    fontFamily: "'KozGoPr6N-Regular-83pv-RKSJ-H'",
    fontSize: "8.1415px"
  }, "\u984D"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.7493 0 0 -0.75 120.8401 479.6022)",
    fontFamily: "'KozGoPr6N-Regular-83pv-RKSJ-H'",
    fontSize: "8.1415px"
  }, "("), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.7493 0 0 -0.75 123.9602 479.6022)",
    fontFamily: "'KozGoPr6N-Regular-83pv-RKSJ-H'",
    fontSize: "8.1415px"
  }, "1"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.7493 0 0 -0.75 127.08 479.6022)",
    fontFamily: "'KozGoPr6N-Regular-83pv-RKSJ-H'",
    fontSize: "8.1415px"
  }, "2"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.7493 0 0 -0.75 130.1997 479.6022)",
    fontFamily: "'KozGoPr6N-Regular-83pv-RKSJ-H'",
    fontSize: "8.1415px"
  }, ")"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.7493 0 0 -0.75 133.8 479.6022)",
    fontFamily: "'KozGoPr6N-Regular-83pv-RKSJ-H'",
    fontSize: "8.1415px"
  }, "\uFF0D"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.7493 0 0 -0.75 140.5188 479.6022)",
    fontFamily: "'KozGoPr6N-Regular-83pv-RKSJ-H'",
    fontSize: "8.1415px"
  }, "("), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.7493 0 0 -0.75 143.6389 479.6022)",
    fontFamily: "'KozGoPr6N-Regular-83pv-RKSJ-H'",
    fontSize: "8.1415px"
  }, "1"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.7493 0 0 -0.75 146.7591 479.6022)",
    fontFamily: "'KozGoPr6N-Regular-83pv-RKSJ-H'",
    fontSize: "8.1415px"
  }, "3"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.7493 0 0 -0.75 149.8792 479.6022)",
    fontFamily: "'KozGoPr6N-Regular-83pv-RKSJ-H'",
    fontSize: "8.1415px"
  }, ")"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.7493 0 0 -0.75 203.7598 484.2824)",
    fontFamily: "'KozGoPr6N-Regular-83pv-RKSJ-H'",
    fontSize: "8.1415px"
  }, "1"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.7493 0 0 -0.75 206.8799 484.2824)",
    fontFamily: "'KozGoPr6N-Regular-83pv-RKSJ-H'",
    fontSize: "8.1415px"
  }, "4"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.7493 0 0 -0.75 426.5999 551.2419)",
    fontFamily: "'KozGoPr6N-Regular-83pv-RKSJ-H'",
    fontSize: "8.1415px"
  }, "\u30FB"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.7493 0 0 -0.75 432.8402 551.2419)",
    fontFamily: "'KozGoPr6N-Regular-83pv-RKSJ-H'",
    fontSize: "8.1415px"
  }), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.7493 0 0 -0.75 435.9603 551.2419)",
    fontFamily: "'KozGoPr6N-Regular-83pv-RKSJ-H'",
    fontSize: "8.1415px"
  }), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.7493 0 0 -0.75 442.1998 551.2419)",
    fontFamily: "'KozGoPr6N-Regular-83pv-RKSJ-H'",
    fontSize: "8.1415px"
  }, "\u30FB"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.7493 0 0 -0.75 426.5999 544.0422)",
    fontFamily: "'KozGoPr6N-Regular-83pv-RKSJ-H'",
    fontSize: "8.1415px"
  }, "\u30FB"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.7493 0 0 -0.75 432.8402 544.0422)",
    fontFamily: "'KozGoPr6N-Regular-83pv-RKSJ-H'",
    fontSize: "8.1415px"
  }), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.7493 0 0 -0.75 435.9603 544.0422)",
    fontFamily: "'KozGoPr6N-Regular-83pv-RKSJ-H'",
    fontSize: "8.1415px"
  }), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.7493 0 0 -0.75 442.1998 544.0422)",
    fontFamily: "'KozGoPr6N-Regular-83pv-RKSJ-H'",
    fontSize: "8.1415px"
  }, "\u30FB"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.7493 0 0 -0.75 489.9603 551.2419)",
    fontFamily: "'KozGoPr6N-Regular-83pv-RKSJ-H'",
    fontSize: "8.1415px"
  }, "\u30FB"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.7493 0 0 -0.75 496.1998 551.2419)",
    fontFamily: "'KozGoPr6N-Regular-83pv-RKSJ-H'",
    fontSize: "8.1415px"
  }), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.7493 0 0 -0.75 499.3199 551.2419)",
    fontFamily: "'KozGoPr6N-Regular-83pv-RKSJ-H'",
    fontSize: "8.1415px"
  }), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.7493 0 0 -0.75 505.5602 551.2419)",
    fontFamily: "'KozGoPr6N-Regular-83pv-RKSJ-H'",
    fontSize: "8.1415px"
  }, "\u30FB"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.7493 0 0 -0.75 489.9603 544.0422)",
    fontFamily: "'KozGoPr6N-Regular-83pv-RKSJ-H'",
    fontSize: "8.1415px"
  }, "\u30FB"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.7493 0 0 -0.75 496.1998 544.0422)",
    fontFamily: "'KozGoPr6N-Regular-83pv-RKSJ-H'",
    fontSize: "8.1415px"
  }), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.7493 0 0 -0.75 499.3199 544.0422)",
    fontFamily: "'KozGoPr6N-Regular-83pv-RKSJ-H'",
    fontSize: "8.1415px"
  }), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.7493 0 0 -0.75 505.5602 544.0422)",
    fontFamily: "'KozGoPr6N-Regular-83pv-RKSJ-H'",
    fontSize: "8.1415px"
  }, "\u30FB"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.7493 0 0 -0.75 77.64 526.5219)",
    fontFamily: "'KozGoPr6N-Regular-83pv-RKSJ-H'",
    fontSize: "8.1415px"
  }, "\u53D6"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.7493 0 0 -0.75 90.1201 526.5219)",
    fontFamily: "'KozGoPr6N-Regular-83pv-RKSJ-H'",
    fontSize: "8.1415px"
  }, "\u5F97"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.7493 0 0 -0.75 102.5999 526.5219)",
    fontFamily: "'KozGoPr6N-Regular-83pv-RKSJ-H'",
    fontSize: "8.1415px"
  }, "\u4FA1"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.7493 0 0 -0.75 115.08 526.5219)",
    fontFamily: "'KozGoPr6N-Regular-83pv-RKSJ-H'",
    fontSize: "8.1415px"
  }, "\u984D"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.7493 0 0 -0.75 127.5601 526.5219)",
    fontFamily: "'KozGoPr6N-Regular-83pv-RKSJ-H'",
    fontSize: "8.1415px"
  }, "\u53C8"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.7493 0 0 -0.75 140.0398 526.5219)",
    fontFamily: "'KozGoPr6N-Regular-83pv-RKSJ-H'",
    fontSize: "8.1415px"
  }, "\u306F"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.7493 0 0 -0.75 152.6401 526.5219)",
    fontFamily: "'KozGoPr6N-Regular-83pv-RKSJ-H'",
    fontSize: "8.1415px"
  }, "\u88FD"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.7493 0 0 -0.75 165.1202 526.5219)",
    fontFamily: "'KozGoPr6N-Regular-83pv-RKSJ-H'",
    fontSize: "8.1415px"
  }, "\u4F5C"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.7493 0 0 -0.75 177.72 526.5219)",
    fontFamily: "'KozGoPr6N-Regular-83pv-RKSJ-H'",
    fontSize: "8.1415px"
  }, "\u4FA1"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.7493 0 0 -0.75 190.1998 526.5219)",
    fontFamily: "'KozGoPr6N-Regular-83pv-RKSJ-H'",
    fontSize: "8.1415px"
  }, "\u984D"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.7493 0 0 -0.75 203.7591 526.5219)",
    fontFamily: "'KozGoPr6N-Regular-83pv-RKSJ-H'",
    fontSize: "8.1415px"
  }, "1"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.7493 0 0 -0.75 206.8792 526.5219)",
    fontFamily: "'KozGoPr6N-Regular-83pv-RKSJ-H'",
    fontSize: "8.1415px"
  }, "2"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.7493 0 0 -0.75 216.8401 533.0016)",
    fontFamily: "'KozGoPr6N-Regular-83pv-RKSJ-H'",
    fontSize: "8.1415px"
  }, "\u5916"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.7493 0 0 -0.75 271.7989 533.0016)",
    fontFamily: "'KozGoPr6N-Regular-83pv-RKSJ-H'",
    fontSize: "8.1415px"
  }, "\u5186"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.7493 0 0 -0.75 280.199 533.0016)",
    fontFamily: "'KozGoPr6N-Regular-83pv-RKSJ-H'",
    fontSize: "8.1415px"
  }, "\u5916"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.7493 0 0 -0.75 335.1578 533.0016)",
    fontFamily: "'KozGoPr6N-Regular-83pv-RKSJ-H'",
    fontSize: "8.1415px"
  }, "\u5186"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.7493 0 0 -0.75 343.558 533.0016)",
    fontFamily: "'KozGoPr6N-Regular-83pv-RKSJ-H'",
    fontSize: "8.1415px"
  }, "\u5916"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.7493 0 0 -0.75 398.5167 533.0016)",
    fontFamily: "'KozGoPr6N-Regular-83pv-RKSJ-H'",
    fontSize: "8.1415px"
  }, "\u5186"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.7493 0 0 -0.75 406.9168 533.0016)",
    fontFamily: "'KozGoPr6N-Regular-83pv-RKSJ-H'",
    fontSize: "8.1415px"
  }, "\u5916"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.7493 0 0 -0.75 461.8763 533.0016)",
    fontFamily: "'KozGoPr6N-Regular-83pv-RKSJ-H'",
    fontSize: "8.1415px"
  }, "\u5186"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.7493 0 0 -0.75 470.2758 533.0016)",
    fontFamily: "'KozGoPr6N-Regular-83pv-RKSJ-H'",
    fontSize: "8.1415px"
  }, "\u5916"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.7493 0 0 -0.75 525.2352 533.0016)",
    fontFamily: "'KozGoPr6N-Regular-83pv-RKSJ-H'",
    fontSize: "8.1415px"
  }, "\u5186"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.7493 0 0 -0.75 67.6802 544.8823)",
    fontFamily: "'KozGoPr6N-Regular-83pv-RKSJ-H'",
    fontSize: "8.1415px"
  }, "\u65E7"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.7493 0 0 -0.75 67.6802 532.4128)",
    fontFamily: "'KozGoPr6N-Regular-83pv-RKSJ-H'",
    fontSize: "8.1415px"
  }, "\u30EA"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0, -1, 1, 0, 70, 522.5644)",
    fontFamily: "'KozGoPr6N-Regular-83pv-RKSJ-H'",
    fontSize: "8.1333px",
    glyphOrientationVertical: 0,
    writingMode: "tb"
  }, "|"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.7493 0 0 -0.75 67.6802 507.3222)",
    fontFamily: "'KozGoPr6N-Regular-83pv-RKSJ-H'",
    fontSize: "8.1415px"
  }, "\u30B9"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.7493 0 0 -0.75 67.6802 494.8527)",
    fontFamily: "'KozGoPr6N-Regular-83pv-RKSJ-H'",
    fontSize: "8.1415px"
  }, "\u671F"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.7493 0 0 -0.75 67.6802 482.3832)",
    fontFamily: "'KozGoPr6N-Regular-83pv-RKSJ-H'",
    fontSize: "8.1415px"
  }, "\u9593"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.7493 0 0 -0.75 67.6802 469.9138)",
    fontFamily: "'KozGoPr6N-Regular-83pv-RKSJ-H'",
    fontSize: "8.1415px"
  }, "\u5B9A"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.7493 0 0 -0.75 67.6802 457.4443)",
    fontFamily: "'KozGoPr6N-Regular-83pv-RKSJ-H'",
    fontSize: "8.1415px"
  }, "\u984D"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.7493 0 0 -0.75 67.6802 444.8547)",
    fontFamily: "'KozGoPr6N-Regular-83pv-RKSJ-H'",
    fontSize: "8.1415px"
  }, "\u6CD5"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.7493 0 0 -0.75 77.64 547.642)",
    fontFamily: "'KozGoPr6N-Regular-83pv-RKSJ-H'",
    fontSize: "8.1415px"
  }, "\u65E7"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.7493 0 0 -0.75 84.2399 547.642)",
    fontFamily: "'KozGoPr6N-Regular-83pv-RKSJ-H'",
    fontSize: "8.1415px"
  }, "\u30EA"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.7493 0 0 -0.75 90.8401 547.642)",
    fontFamily: "'KozGoPr6N-Regular-83pv-RKSJ-H'",
    fontSize: "8.1415px"
  }, "\u30FC"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.7493 0 0 -0.75 97.44 547.642)",
    fontFamily: "'KozGoPr6N-Regular-83pv-RKSJ-H'",
    fontSize: "8.1415px"
  }, "\u30B9"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.7493 0 0 -0.75 104.0398 547.642)",
    fontFamily: "'KozGoPr6N-Regular-83pv-RKSJ-H'",
    fontSize: "8.1415px"
  }, "\u671F"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.7493 0 0 -0.75 110.64 547.642)",
    fontFamily: "'KozGoPr6N-Regular-83pv-RKSJ-H'",
    fontSize: "8.1415px"
  }, "\u9593"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.7493 0 0 -0.75 117.2399 547.642)",
    fontFamily: "'KozGoPr6N-Regular-83pv-RKSJ-H'",
    fontSize: "8.1415px"
  }, "\u5B9A"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.7493 0 0 -0.75 123.8401 547.642)",
    fontFamily: "'KozGoPr6N-Regular-83pv-RKSJ-H'",
    fontSize: "8.1415px"
  }, "\u984D"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.7493 0 0 -0.75 130.44 547.642)",
    fontFamily: "'KozGoPr6N-Regular-83pv-RKSJ-H'",
    fontSize: "8.1415px"
  }, "\u6CD5"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.7493 0 0 -0.75 137.0398 547.642)",
    fontFamily: "'KozGoPr6N-Regular-83pv-RKSJ-H'",
    fontSize: "8.1415px"
  }, "\u3092"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.7493 0 0 -0.75 143.64 547.642)",
    fontFamily: "'KozGoPr6N-Regular-83pv-RKSJ-H'",
    fontSize: "8.1415px"
  }, "\u63A1"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.7493 0 0 -0.75 150.2399 547.642)",
    fontFamily: "'KozGoPr6N-Regular-83pv-RKSJ-H'",
    fontSize: "8.1415px"
  }, "\u7528"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.7493 0 0 -0.75 156.9588 547.642)",
    fontFamily: "'KozGoPr6N-Regular-83pv-RKSJ-H'",
    fontSize: "8.1415px"
  }, "\u3057"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.7493 0 0 -0.75 163.559 547.642)",
    fontFamily: "'KozGoPr6N-Regular-83pv-RKSJ-H'",
    fontSize: "8.1415px"
  }, "\u305F"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.7493 0 0 -0.75 170.2779 547.642)",
    fontFamily: "'KozGoPr6N-Regular-83pv-RKSJ-H'",
    fontSize: "8.1415px"
  }, "\u4E8B"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.7493 0 0 -0.75 176.8777 547.642)",
    fontFamily: "'KozGoPr6N-Regular-83pv-RKSJ-H'",
    fontSize: "8.1415px"
  }, "\u696D"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.7493 0 0 -0.75 183.597 547.642)",
    fontFamily: "'KozGoPr6N-Regular-83pv-RKSJ-H'",
    fontSize: "8.1415px"
  }, "\u5E74"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.7493 0 0 -0.75 190.1968 547.642)",
    fontFamily: "'KozGoPr6N-Regular-83pv-RKSJ-H'",
    fontSize: "8.1415px"
  }, "\u5EA6"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.7493 0 0 -0.75 203.7561 547.642)",
    fontFamily: "'KozGoPr6N-Regular-83pv-RKSJ-H'",
    fontSize: "8.1415px"
  }, "1"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.7493 0 0 -0.75 206.8763 547.642)",
    fontFamily: "'KozGoPr6N-Regular-83pv-RKSJ-H'",
    fontSize: "8.1415px"
  }, "1"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.7493 0 0 -0.75 236.5196 551.2419)",
    fontFamily: "'KozGoPr6N-Regular-83pv-RKSJ-H'",
    fontSize: "8.1415px"
  }, "\u30FB"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.7493 0 0 -0.75 242.7598 551.2419)",
    fontFamily: "'KozGoPr6N-Regular-83pv-RKSJ-H'",
    fontSize: "8.1415px"
  }), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.7493 0 0 -0.75 245.8799 551.2419)",
    fontFamily: "'KozGoPr6N-Regular-83pv-RKSJ-H'",
    fontSize: "8.1415px"
  }), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.7493 0 0 -0.75 252.1202 551.2419)",
    fontFamily: "'KozGoPr6N-Regular-83pv-RKSJ-H'",
    fontSize: "8.1415px"
  }, "\u30FB"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.7493 0 0 -0.75 236.5196 544.0422)",
    fontFamily: "'KozGoPr6N-Regular-83pv-RKSJ-H'",
    fontSize: "8.1415px"
  }, "\u30FB"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.7493 0 0 -0.75 242.7598 544.0422)",
    fontFamily: "'KozGoPr6N-Regular-83pv-RKSJ-H'",
    fontSize: "8.1415px"
  }), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.7493 0 0 -0.75 245.8799 544.0422)",
    fontFamily: "'KozGoPr6N-Regular-83pv-RKSJ-H'",
    fontSize: "8.1415px"
  }), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.7493 0 0 -0.75 252.1202 544.0422)",
    fontFamily: "'KozGoPr6N-Regular-83pv-RKSJ-H'",
    fontSize: "8.1415px"
  }, "\u30FB"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.7493 0 0 -0.75 299.8799 551.2419)",
    fontFamily: "'KozGoPr6N-Regular-83pv-RKSJ-H'",
    fontSize: "8.1415px"
  }, "\u30FB"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.7493 0 0 -0.75 306.1202 551.2419)",
    fontFamily: "'KozGoPr6N-Regular-83pv-RKSJ-H'",
    fontSize: "8.1415px"
  }), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.7493 0 0 -0.75 309.2403 551.2419)",
    fontFamily: "'KozGoPr6N-Regular-83pv-RKSJ-H'",
    fontSize: "8.1415px"
  }), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.7493 0 0 -0.75 315.4798 551.2419)",
    fontFamily: "'KozGoPr6N-Regular-83pv-RKSJ-H'",
    fontSize: "8.1415px"
  }, "\u30FB"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.7493 0 0 -0.75 299.8799 544.0422)",
    fontFamily: "'KozGoPr6N-Regular-83pv-RKSJ-H'",
    fontSize: "8.1415px"
  }, "\u30FB"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.7493 0 0 -0.75 306.1202 544.0422)",
    fontFamily: "'KozGoPr6N-Regular-83pv-RKSJ-H'",
    fontSize: "8.1415px"
  }), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.7493 0 0 -0.75 309.2403 544.0422)",
    fontFamily: "'KozGoPr6N-Regular-83pv-RKSJ-H'",
    fontSize: "8.1415px"
  }), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.7493 0 0 -0.75 315.4798 544.0422)",
    fontFamily: "'KozGoPr6N-Regular-83pv-RKSJ-H'",
    fontSize: "8.1415px"
  }, "\u30FB"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.7493 0 0 -0.75 363.2403 551.2419)",
    fontFamily: "'KozGoPr6N-Regular-83pv-RKSJ-H'",
    fontSize: "8.1415px"
  }, "\u30FB"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.7493 0 0 -0.75 369.4798 551.2419)",
    fontFamily: "'KozGoPr6N-Regular-83pv-RKSJ-H'",
    fontSize: "8.1415px"
  }), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.7493 0 0 -0.75 372.5999 551.2419)",
    fontFamily: "'KozGoPr6N-Regular-83pv-RKSJ-H'",
    fontSize: "8.1415px"
  }), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.7493 0 0 -0.75 378.8402 551.2419)",
    fontFamily: "'KozGoPr6N-Regular-83pv-RKSJ-H'",
    fontSize: "8.1415px"
  }, "\u30FB"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.7493 0 0 -0.75 363.2403 544.0422)",
    fontFamily: "'KozGoPr6N-Regular-83pv-RKSJ-H'",
    fontSize: "8.1415px"
  }, "\u30FB"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.7493 0 0 -0.75 369.4798 544.0422)",
    fontFamily: "'KozGoPr6N-Regular-83pv-RKSJ-H'",
    fontSize: "8.1415px"
  }), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.7493 0 0 -0.75 372.5999 544.0422)",
    fontFamily: "'KozGoPr6N-Regular-83pv-RKSJ-H'",
    fontSize: "8.1415px"
  }), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.7493 0 0 -0.75 378.8402 544.0422)",
    fontFamily: "'KozGoPr6N-Regular-83pv-RKSJ-H'",
    fontSize: "8.1415px"
  }, "\u30FB"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.7493 0 0 -0.75 77.64 509.0016)",
    fontFamily: "'KozGoPr6N-Regular-83pv-RKSJ-H'",
    fontSize: "8.1415px"
  }, "("), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.7493 0 0 -0.75 80.7598 509.0016)",
    fontFamily: "'KozGoPr6N-Regular-83pv-RKSJ-H'",
    fontSize: "8.1415px"
  }, "1"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.7493 0 0 -0.75 83.8799 509.0016)",
    fontFamily: "'KozGoPr6N-Regular-83pv-RKSJ-H'",
    fontSize: "8.1415px"
  }, "2"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.7493 0 0 -0.75 87 509.0016)",
    fontFamily: "'KozGoPr6N-Regular-83pv-RKSJ-H'",
    fontSize: "8.1415px"
  }, ")"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.7493 0 0 -0.75 90.1201 509.0016)",
    fontFamily: "'KozGoPr6N-Regular-83pv-RKSJ-H'",
    fontSize: "8.1415px"
  }, "\u306E"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.7493 0 0 -0.75 96.36 509.0016)",
    fontFamily: "'KozGoPr6N-Regular-83pv-RKSJ-H'",
    fontSize: "8.1415px"
  }, "\u3046"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.7493 0 0 -0.75 102.5999 509.0016)",
    fontFamily: "'KozGoPr6N-Regular-83pv-RKSJ-H'",
    fontSize: "8.1415px"
  }, "\u3061"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.7493 0 0 -0.75 108.8401 509.0016)",
    fontFamily: "'KozGoPr6N-Regular-83pv-RKSJ-H'",
    fontSize: "8.1415px"
  }, "("), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.7493 0 0 -0.75 111.9602 509.0016)",
    fontFamily: "'KozGoPr6N-Regular-83pv-RKSJ-H'",
    fontSize: "8.1415px"
  }, "1"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.7493 0 0 -0.75 115.08 509.0016)",
    fontFamily: "'KozGoPr6N-Regular-83pv-RKSJ-H'",
    fontSize: "8.1415px"
  }, "1"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.7493 0 0 -0.75 118.1997 509.0016)",
    fontFamily: "'KozGoPr6N-Regular-83pv-RKSJ-H'",
    fontSize: "8.1415px"
  }, ")"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.7493 0 0 -0.75 121.3199 509.0016)",
    fontFamily: "'KozGoPr6N-Regular-83pv-RKSJ-H'",
    fontSize: "8.1415px"
  }, "\u306E"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.7493 0 0 -0.75 127.5601 509.0016)",
    fontFamily: "'KozGoPr6N-Regular-83pv-RKSJ-H'",
    fontSize: "8.1415px"
  }, "\u4E8B"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.7493 0 0 -0.75 133.8 509.0016)",
    fontFamily: "'KozGoPr6N-Regular-83pv-RKSJ-H'",
    fontSize: "8.1415px"
  }, "\u696D"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.7493 0 0 -0.75 140.0398 509.0016)",
    fontFamily: "'KozGoPr6N-Regular-83pv-RKSJ-H'",
    fontSize: "8.1415px"
  }, "\u5E74"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.7493 0 0 -0.75 146.2801 509.0016)",
    fontFamily: "'KozGoPr6N-Regular-83pv-RKSJ-H'",
    fontSize: "8.1415px"
  }, "\u5EA6"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.7493 0 0 -0.75 152.5199 509.0016)",
    fontFamily: "'KozGoPr6N-Regular-83pv-RKSJ-H'",
    fontSize: "8.1415px"
  }, "\u524D"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.7493 0 0 -0.75 158.7598 509.0016)",
    fontFamily: "'KozGoPr6N-Regular-83pv-RKSJ-H'",
    fontSize: "8.1415px"
  }, "\u306B"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.7493 0 0 -0.75 165 509.0016)",
    fontFamily: "'KozGoPr6N-Regular-83pv-RKSJ-H'",
    fontSize: "8.1415px"
  }, "\u640D"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.7493 0 0 -0.75 171.36 509.0016)",
    fontFamily: "'KozGoPr6N-Regular-83pv-RKSJ-H'",
    fontSize: "8.1415px"
  }, "\u91D1"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.7493 0 0 -0.75 177.5999 509.0016)",
    fontFamily: "'KozGoPr6N-Regular-83pv-RKSJ-H'",
    fontSize: "8.1415px"
  }, "\u306E"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.7493 0 0 -0.75 183.9603 509.0016)",
    fontFamily: "'KozGoPr6N-Regular-83pv-RKSJ-H'",
    fontSize: "8.1415px"
  }, "\u984D"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.7493 0 0 -0.75 190.1998 509.0016)",
    fontFamily: "'KozGoPr6N-Regular-83pv-RKSJ-H'",
    fontSize: "8.1415px"
  }, "\u306B"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.7493 0 0 -0.75 77.64 501.8019)",
    fontFamily: "'KozGoPr6N-Regular-83pv-RKSJ-H'",
    fontSize: "8.1415px"
  }, "\u7B97"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.7493 0 0 -0.75 84.72 501.8019)",
    fontFamily: "'KozGoPr6N-Regular-83pv-RKSJ-H'",
    fontSize: "8.1415px"
  }, "\u5165"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.7493 0 0 -0.75 91.7999 501.8019)",
    fontFamily: "'KozGoPr6N-Regular-83pv-RKSJ-H'",
    fontSize: "8.1415px"
  }, "\u3055"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.7493 0 0 -0.75 98.8799 501.8019)",
    fontFamily: "'KozGoPr6N-Regular-83pv-RKSJ-H'",
    fontSize: "8.1415px"
  }, "\u308C"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.7493 0 0 -0.75 105.9602 501.8019)",
    fontFamily: "'KozGoPr6N-Regular-83pv-RKSJ-H'",
    fontSize: "8.1415px"
  }, "\u305F"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.7493 0 0 -0.75 113.0398 501.8019)",
    fontFamily: "'KozGoPr6N-Regular-83pv-RKSJ-H'",
    fontSize: "8.1415px"
  }, "\u91D1"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.7493 0 0 -0.75 120 501.8019)",
    fontFamily: "'KozGoPr6N-Regular-83pv-RKSJ-H'",
    fontSize: "8.1415px"
  }, "\u984D"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.7493 0 0 -0.75 203.7598 505.4025)",
    fontFamily: "'KozGoPr6N-Regular-83pv-RKSJ-H'",
    fontSize: "8.1415px"
  }, "1"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.7493 0 0 -0.75 206.8799 505.4025)",
    fontFamily: "'KozGoPr6N-Regular-83pv-RKSJ-H'",
    fontSize: "8.1415px"
  }, "3"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.7493 0 0 -0.75 77.64 573.4423)",
    fontFamily: "'KozGoPr6N-Regular-83pv-RKSJ-H'",
    fontSize: "8.1415px"
  }, "\u511F"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.7493 0 0 -0.75 87 573.4423)",
    fontFamily: "'KozGoPr6N-Regular-83pv-RKSJ-H'",
    fontSize: "8.1415px"
  }, "\u5374"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.7493 0 0 -0.75 96.36 573.4423)",
    fontFamily: "'KozGoPr6N-Regular-83pv-RKSJ-H'",
    fontSize: "8.1415px"
  }, "\u984D"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.7493 0 0 -0.75 105.72 573.4423)",
    fontFamily: "'KozGoPr6N-Regular-83pv-RKSJ-H'",
    fontSize: "8.1415px"
  }, "\u8A08"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.7493 0 0 -0.75 115.08 573.4423)",
    fontFamily: "'KozGoPr6N-Regular-83pv-RKSJ-H'",
    fontSize: "8.1415px"
  }, "\u7B97"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.7493 0 0 -0.75 124.44 573.4423)",
    fontFamily: "'KozGoPr6N-Regular-83pv-RKSJ-H'",
    fontSize: "8.1415px"
  }, "\u306E"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.7493 0 0 -0.75 133.8 573.4423)",
    fontFamily: "'KozGoPr6N-Regular-83pv-RKSJ-H'",
    fontSize: "8.1415px"
  }, "\u57FA"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.7493 0 0 -0.75 143.1599 573.4423)",
    fontFamily: "'KozGoPr6N-Regular-83pv-RKSJ-H'",
    fontSize: "8.1415px"
  }, "\u790E"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.7493 0 0 -0.75 152.5199 573.4423)",
    fontFamily: "'KozGoPr6N-Regular-83pv-RKSJ-H'",
    fontSize: "8.1415px"
  }, "\u3068"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.7493 0 0 -0.75 162 573.4423)",
    fontFamily: "'KozGoPr6N-Regular-83pv-RKSJ-H'",
    fontSize: "8.1415px"
  }, "\u306A"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.7493 0 0 -0.75 171.36 573.4423)",
    fontFamily: "'KozGoPr6N-Regular-83pv-RKSJ-H'",
    fontSize: "8.1415px"
  }, "\u308B"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.7493 0 0 -0.75 180.8401 573.4423)",
    fontFamily: "'KozGoPr6N-Regular-83pv-RKSJ-H'",
    fontSize: "8.1415px"
  }, "\u91D1"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.7493 0 0 -0.75 190.1998 573.4423)",
    fontFamily: "'KozGoPr6N-Regular-83pv-RKSJ-H'",
    fontSize: "8.1415px"
  }, "\u984D"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.7493 0 0 -0.75 123.9588 564.082)",
    fontFamily: "'KozGoPr6N-Regular-83pv-RKSJ-H'",
    fontSize: "8.1415px"
  }, "("), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.7493 0 0 -0.75 127.0789 564.082)",
    fontFamily: "'KozGoPr6N-Regular-83pv-RKSJ-H'",
    fontSize: "8.1415px"
  }, "8"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.7493 0 0 -0.75 130.199 564.082)",
    fontFamily: "'KozGoPr6N-Regular-83pv-RKSJ-H'",
    fontSize: "8.1415px"
  }, ")"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.7493 0 0 -0.75 133.7989 564.082)",
    fontFamily: "'KozGoPr6N-Regular-83pv-RKSJ-H'",
    fontSize: "8.1415px"
  }, "\uFF0D"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.7493 0 0 -0.75 140.5181 564.082)",
    fontFamily: "'KozGoPr6N-Regular-83pv-RKSJ-H'",
    fontSize: "8.1415px"
  }, "("), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.7493 0 0 -0.75 143.6382 564.082)",
    fontFamily: "'KozGoPr6N-Regular-83pv-RKSJ-H'",
    fontSize: "8.1415px"
  }, "9"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.7493 0 0 -0.75 146.758 564.082)",
    fontFamily: "'KozGoPr6N-Regular-83pv-RKSJ-H'",
    fontSize: "8.1415px"
  }, ")"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.7493 0 0 -0.75 203.7598 568.7621)",
    fontFamily: "'KozGoPr6N-Regular-83pv-RKSJ-H'",
    fontSize: "8.1415px"
  }, "1"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.7493 0 0 -0.75 206.8799 568.7621)",
    fontFamily: "'KozGoPr6N-Regular-83pv-RKSJ-H'",
    fontSize: "8.1415px"
  }, "0"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.7493 0 0 -0.75 77.64 589.8823)",
    fontFamily: "'KozGoPr6N-Regular-83pv-RKSJ-H'",
    fontSize: "8.1415px"
  }, "\u898B"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.7493 0 0 -0.75 100.1997 589.8823)",
    fontFamily: "'KozGoPr6N-Regular-83pv-RKSJ-H'",
    fontSize: "8.1415px"
  }, "\u7A4D"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.7493 0 0 -0.75 122.7598 589.8823)",
    fontFamily: "'KozGoPr6N-Regular-83pv-RKSJ-H'",
    fontSize: "8.1415px"
  }, "\u6B8B"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.7493 0 0 -0.75 145.1997 589.8823)",
    fontFamily: "'KozGoPr6N-Regular-83pv-RKSJ-H'",
    fontSize: "8.1415px"
  }, "\u5B58"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.7493 0 0 -0.75 167.7598 589.8823)",
    fontFamily: "'KozGoPr6N-Regular-83pv-RKSJ-H'",
    fontSize: "8.1415px"
  }, "\u4FA1"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.7493 0 0 -0.75 190.1998 589.8823)",
    fontFamily: "'KozGoPr6N-Regular-83pv-RKSJ-H'",
    fontSize: "8.1415px"
  }, "\u984D"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.7493 0 0 -0.75 205.3199 589.8823)",
    fontFamily: "'KozGoPr6N-Regular-83pv-RKSJ-H'",
    fontSize: "8.1415px"
  }, "9"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.7493 0 0 -0.75 77.64 615.6819)",
    fontFamily: "'KozGoPr6N-Regular-83pv-RKSJ-H'",
    fontSize: "8.1415px"
  }, "\u5DEE"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.7493 0 0 -0.75 100.1997 615.6819)",
    fontFamily: "'KozGoPr6N-Regular-83pv-RKSJ-H'",
    fontSize: "8.1415px"
  }, "\u5F15"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.7493 0 0 -0.75 122.7598 615.6819)",
    fontFamily: "'KozGoPr6N-Regular-83pv-RKSJ-H'",
    fontSize: "8.1415px"
  }, "\u53D6"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.7493 0 0 -0.75 145.1997 615.6819)",
    fontFamily: "'KozGoPr6N-Regular-83pv-RKSJ-H'",
    fontSize: "8.1415px"
  }, "\u5F97"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.7493 0 0 -0.75 167.7598 615.6819)",
    fontFamily: "'KozGoPr6N-Regular-83pv-RKSJ-H'",
    fontSize: "8.1415px"
  }, "\u4FA1"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.7493 0 0 -0.75 190.1998 615.6819)",
    fontFamily: "'KozGoPr6N-Regular-83pv-RKSJ-H'",
    fontSize: "8.1415px"
  }, "\u984D"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.7493 0 0 -0.75 123.9588 606.3222)",
    fontFamily: "'KozGoPr6N-Regular-83pv-RKSJ-H'",
    fontSize: "8.1415px"
  }, "("), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.7493 0 0 -0.75 127.0789 606.3222)",
    fontFamily: "'KozGoPr6N-Regular-83pv-RKSJ-H'",
    fontSize: "8.1415px"
  }, "6"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.7493 0 0 -0.75 130.199 606.3222)",
    fontFamily: "'KozGoPr6N-Regular-83pv-RKSJ-H'",
    fontSize: "8.1415px"
  }, ")"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.7493 0 0 -0.75 133.7989 606.3222)",
    fontFamily: "'KozGoPr6N-Regular-83pv-RKSJ-H'",
    fontSize: "8.1415px"
  }, "\uFF0D"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.7493 0 0 -0.75 140.5181 606.3222)",
    fontFamily: "'KozGoPr6N-Regular-83pv-RKSJ-H'",
    fontSize: "8.1415px"
  }, "("), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.7493 0 0 -0.75 143.6382 606.3222)",
    fontFamily: "'KozGoPr6N-Regular-83pv-RKSJ-H'",
    fontSize: "8.1415px"
  }, "7"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.7493 0 0 -0.75 146.758 606.3222)",
    fontFamily: "'KozGoPr6N-Regular-83pv-RKSJ-H'",
    fontSize: "8.1415px"
  }, ")"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.7493 0 0 -0.75 205.3199 611.0021)",
    fontFamily: "'KozGoPr6N-Regular-83pv-RKSJ-H'",
    fontSize: "8.1415px"
  }, "8"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.7493 0 0 -0.75 77.64 640.522)",
    fontFamily: "'KozGoPr6N-Regular-83pv-RKSJ-H'",
    fontSize: "8.1415px"
  }, "("), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.7493 0 0 -0.75 80.7598 640.522)",
    fontFamily: "'KozGoPr6N-Regular-83pv-RKSJ-H'",
    fontSize: "8.1415px"
  }, "6"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.7493 0 0 -0.75 83.8799 640.522)",
    fontFamily: "'KozGoPr6N-Regular-83pv-RKSJ-H'",
    fontSize: "8.1415px"
  }, ")"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.7493 0 0 -0.75 87.2388 640.522)",
    fontFamily: "'KozGoPr6N-Regular-83pv-RKSJ-H'",
    fontSize: "8.1415px"
  }, "\u306E"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.7493 0 0 -0.75 93.7189 640.522)",
    fontFamily: "'KozGoPr6N-Regular-83pv-RKSJ-H'",
    fontSize: "8.1415px"
  }, "\u3046"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.7493 0 0 -0.75 100.199 640.522)",
    fontFamily: "'KozGoPr6N-Regular-83pv-RKSJ-H'",
    fontSize: "8.1415px"
  }, "\u3061"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.7493 0 0 -0.75 106.6787 640.522)",
    fontFamily: "'KozGoPr6N-Regular-83pv-RKSJ-H'",
    fontSize: "8.1415px"
  }, "\u7A4D"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.7493 0 0 -0.75 113.1592 640.522)",
    fontFamily: "'KozGoPr6N-Regular-83pv-RKSJ-H'",
    fontSize: "8.1415px"
  }, "\u7ACB"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.7493 0 0 -0.75 119.6389 640.522)",
    fontFamily: "'KozGoPr6N-Regular-83pv-RKSJ-H'",
    fontSize: "8.1415px"
  }, "\u91D1"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.7493 0 0 -0.75 125.9989 640.522)",
    fontFamily: "'KozGoPr6N-Regular-83pv-RKSJ-H'",
    fontSize: "8.1415px"
  }, "\u65B9"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.7493 0 0 -0.75 132.479 640.522)",
    fontFamily: "'KozGoPr6N-Regular-83pv-RKSJ-H'",
    fontSize: "8.1415px"
  }, "\u5F0F"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.7493 0 0 -0.75 138.839 640.522)",
    fontFamily: "'KozGoPr6N-Regular-83pv-RKSJ-H'",
    fontSize: "8.1415px"
  }, "\u306B"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.7493 0 0 -0.75 145.3191 640.522)",
    fontFamily: "'KozGoPr6N-Regular-83pv-RKSJ-H'",
    fontSize: "8.1415px"
  }, "\u3088"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.7493 0 0 -0.75 151.6787 640.522)",
    fontFamily: "'KozGoPr6N-Regular-83pv-RKSJ-H'",
    fontSize: "8.1415px"
  }, "\u308B"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.7493 0 0 -0.75 158.1592 640.522)",
    fontFamily: "'KozGoPr6N-Regular-83pv-RKSJ-H'",
    fontSize: "8.1415px"
  }, "\u5727"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.7493 0 0 -0.75 164.5188 640.522)",
    fontFamily: "'KozGoPr6N-Regular-83pv-RKSJ-H'",
    fontSize: "8.1415px"
  }, "\u7E2E"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.7493 0 0 -0.75 170.9989 640.522)",
    fontFamily: "'KozGoPr6N-Regular-83pv-RKSJ-H'",
    fontSize: "8.1415px"
  }, "\u8A18"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.7493 0 0 -0.75 177.3589 640.522)",
    fontFamily: "'KozGoPr6N-Regular-83pv-RKSJ-H'",
    fontSize: "8.1415px"
  }, "\u5E33"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.7493 0 0 -0.75 183.839 640.522)",
    fontFamily: "'KozGoPr6N-Regular-83pv-RKSJ-H'",
    fontSize: "8.1415px"
  }, "\u306E"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.7493 0 0 -0.75 190.199 640.522)",
    fontFamily: "'KozGoPr6N-Regular-83pv-RKSJ-H'",
    fontSize: "8.1415px"
  }, "\u5834"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.7493 0 0 -0.75 77.64 633.3223)",
    fontFamily: "'KozGoPr6N-Regular-83pv-RKSJ-H'",
    fontSize: "8.1415px"
  }, "\u5408"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.7493 0 0 -0.75 83.8799 633.3223)",
    fontFamily: "'KozGoPr6N-Regular-83pv-RKSJ-H'",
    fontSize: "8.1415px"
  }, "\u306E"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.7493 0 0 -0.75 90.1201 633.3223)",
    fontFamily: "'KozGoPr6N-Regular-83pv-RKSJ-H'",
    fontSize: "8.1415px"
  }, "\u511F"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.7493 0 0 -0.75 96.36 633.3223)",
    fontFamily: "'KozGoPr6N-Regular-83pv-RKSJ-H'",
    fontSize: "8.1415px"
  }, "\u5374"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.7493 0 0 -0.75 102.5999 633.3223)",
    fontFamily: "'KozGoPr6N-Regular-83pv-RKSJ-H'",
    fontSize: "8.1415px"
  }, "\u984D"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.7493 0 0 -0.75 108.8401 633.3223)",
    fontFamily: "'KozGoPr6N-Regular-83pv-RKSJ-H'",
    fontSize: "8.1415px"
  }, "\u8A08"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.7493 0 0 -0.75 115.08 633.3223)",
    fontFamily: "'KozGoPr6N-Regular-83pv-RKSJ-H'",
    fontSize: "8.1415px"
  }, "\u7B97"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.7493 0 0 -0.75 121.3199 633.3223)",
    fontFamily: "'KozGoPr6N-Regular-83pv-RKSJ-H'",
    fontSize: "8.1415px"
  }, "\u306E"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.7493 0 0 -0.75 127.5601 633.3223)",
    fontFamily: "'KozGoPr6N-Regular-83pv-RKSJ-H'",
    fontSize: "8.1415px"
  }, "\u5BFE"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.7493 0 0 -0.75 133.8 633.3223)",
    fontFamily: "'KozGoPr6N-Regular-83pv-RKSJ-H'",
    fontSize: "8.1415px"
  }, "\u8C61"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.7493 0 0 -0.75 140.0398 633.3223)",
    fontFamily: "'KozGoPr6N-Regular-83pv-RKSJ-H'",
    fontSize: "8.1415px"
  }, "\u3068"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.7493 0 0 -0.75 146.2801 633.3223)",
    fontFamily: "'KozGoPr6N-Regular-83pv-RKSJ-H'",
    fontSize: "8.1415px"
  }, "\u306A"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.7493 0 0 -0.75 152.5199 633.3223)",
    fontFamily: "'KozGoPr6N-Regular-83pv-RKSJ-H'",
    fontSize: "8.1415px"
  }, "\u308B"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.7493 0 0 -0.75 158.7598 633.3223)",
    fontFamily: "'KozGoPr6N-Regular-83pv-RKSJ-H'",
    fontSize: "8.1415px"
  }, "\u53D6"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.7493 0 0 -0.75 165 633.3223)",
    fontFamily: "'KozGoPr6N-Regular-83pv-RKSJ-H'",
    fontSize: "8.1415px"
  }, "\u5F97"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.7493 0 0 -0.75 171.36 633.3223)",
    fontFamily: "'KozGoPr6N-Regular-83pv-RKSJ-H'",
    fontSize: "8.1415px"
  }, "\u4FA1"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.7493 0 0 -0.75 177.5999 633.3223)",
    fontFamily: "'KozGoPr6N-Regular-83pv-RKSJ-H'",
    fontSize: "8.1415px"
  }, "\u984D"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.7493 0 0 -0.75 183.9603 633.3223)",
    fontFamily: "'KozGoPr6N-Regular-83pv-RKSJ-H'",
    fontSize: "8.1415px"
  }, "\u306B"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.7493 0 0 -0.75 190.1998 633.3223)",
    fontFamily: "'KozGoPr6N-Regular-83pv-RKSJ-H'",
    fontSize: "8.1415px"
  }, "\u7B97"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.7493 0 0 -0.75 77.64 626.1222)",
    fontFamily: "'KozGoPr6N-Regular-83pv-RKSJ-H'",
    fontSize: "8.1415px"
  }, "\u5165"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.7493 0 0 -0.75 84.72 626.1222)",
    fontFamily: "'KozGoPr6N-Regular-83pv-RKSJ-H'",
    fontSize: "8.1415px"
  }, "\u3057"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.7493 0 0 -0.75 91.7999 626.1222)",
    fontFamily: "'KozGoPr6N-Regular-83pv-RKSJ-H'",
    fontSize: "8.1415px"
  }, "\u306A"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.7493 0 0 -0.75 98.8799 626.1222)",
    fontFamily: "'KozGoPr6N-Regular-83pv-RKSJ-H'",
    fontSize: "8.1415px"
  }, "\u3044"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.7493 0 0 -0.75 105.9602 626.1222)",
    fontFamily: "'KozGoPr6N-Regular-83pv-RKSJ-H'",
    fontSize: "8.1415px"
  }, "\u91D1"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.7493 0 0 -0.75 113.0398 626.1222)",
    fontFamily: "'KozGoPr6N-Regular-83pv-RKSJ-H'",
    fontSize: "8.1415px"
  }, "\u984D"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.7493 0 0 -0.75 205.3199 633.3223)",
    fontFamily: "'KozGoPr6N-Regular-83pv-RKSJ-H'",
    fontSize: "8.1415px"
  }, "7"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.7493 0 0 -0.75 55.1997 646.2821)",
    fontFamily: "'KozGoPr6N-Regular-83pv-RKSJ-H'",
    fontSize: "8.1415px"
  }, "\u511F"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.7493 0 0 -0.75 55.1997 624.8196)",
    fontFamily: "'KozGoPr6N-Regular-83pv-RKSJ-H'",
    fontSize: "8.1415px"
  }, "\u5374"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.7493 0 0 -0.75 55.1997 603.2372)",
    fontFamily: "'KozGoPr6N-Regular-83pv-RKSJ-H'",
    fontSize: "8.1415px"
  }, "\u984D"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.7493 0 0 -0.75 55.1997 581.7744)",
    fontFamily: "'KozGoPr6N-Regular-83pv-RKSJ-H'",
    fontSize: "8.1415px"
  }, "\u8A08"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.7493 0 0 -0.75 55.1997 560.3122)",
    fontFamily: "'KozGoPr6N-Regular-83pv-RKSJ-H'",
    fontSize: "8.1415px"
  }, "\u7B97"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.7493 0 0 -0.75 55.1997 538.7292)",
    fontFamily: "'KozGoPr6N-Regular-83pv-RKSJ-H'",
    fontSize: "8.1415px"
  }, "\u306E"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.7493 0 0 -0.75 55.1997 517.267)",
    fontFamily: "'KozGoPr6N-Regular-83pv-RKSJ-H'",
    fontSize: "8.1415px"
  }, "\u57FA"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.7493 0 0 -0.75 55.1997 495.8049)",
    fontFamily: "'KozGoPr6N-Regular-83pv-RKSJ-H'",
    fontSize: "8.1415px"
  }, "\u790E"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.7493 0 0 -0.75 55.1997 474.2219)",
    fontFamily: "'KozGoPr6N-Regular-83pv-RKSJ-H'",
    fontSize: "8.1415px"
  }, "\u3068"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.7493 0 0 -0.75 55.1997 452.7597)",
    fontFamily: "'KozGoPr6N-Regular-83pv-RKSJ-H'",
    fontSize: "8.1415px"
  }, "\u306A"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.7493 0 0 -0.75 55.1997 431.2975)",
    fontFamily: "'KozGoPr6N-Regular-83pv-RKSJ-H'",
    fontSize: "8.1415px"
  }, "\u308B"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.7493 0 0 -0.75 55.1997 409.7145)",
    fontFamily: "'KozGoPr6N-Regular-83pv-RKSJ-H'",
    fontSize: "8.1415px"
  }, "\u91D1"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.7493 0 0 -0.75 55.1997 388.1322)",
    fontFamily: "'KozGoPr6N-Regular-83pv-RKSJ-H'",
    fontSize: "8.1415px"
  }, "\u984D"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.7493 0 0 -0.75 67.6802 656.6023)",
    fontFamily: "'KozGoPr6N-Regular-83pv-RKSJ-H'",
    fontSize: "8.1415px"
  }, "\u65E7"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.7493 0 0 -0.75 67.6802 647.8491)",
    fontFamily: "'KozGoPr6N-Regular-83pv-RKSJ-H'",
    fontSize: "8.1415px"
  }, "\u56FD"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.7493 0 0 -0.75 67.6802 639.0967)",
    fontFamily: "'KozGoPr6N-Regular-83pv-RKSJ-H'",
    fontSize: "8.1415px"
  }, "\u5916"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.7493 0 0 -0.75 67.6802 630.1047)",
    fontFamily: "'KozGoPr6N-Regular-83pv-RKSJ-H'",
    fontSize: "8.1415px"
  }, "\u30EA"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0, -1, 1, 0 70 622.9646)",
    fontFamily: "'KozGoPr6N-Regular-83pv-RKSJ-H'",
    fontSize: "8.1333px",
    glyphOrientationVertical: 0,
    writingMode: "tb"
  }, "|"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.7493 0 0 -0.75 67.6802 612.3223)",
    fontFamily: "'KozGoPr6N-Regular-83pv-RKSJ-H'",
    fontSize: "8.1415px"
  }, "\u30B9"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.7493 0 0 -0.75 67.6802 603.4504)",
    fontFamily: "'KozGoPr6N-Regular-83pv-RKSJ-H'",
    fontSize: "8.1415px"
  }, "\u671F"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.7493 0 0 -0.75 67.6802 594.5786)",
    fontFamily: "'KozGoPr6N-Regular-83pv-RKSJ-H'",
    fontSize: "8.1415px"
  }, "\u9593"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.7493 0 0 -0.75 67.6802 585.7067)",
    fontFamily: "'KozGoPr6N-Regular-83pv-RKSJ-H'",
    fontSize: "8.1415px"
  }, "\u5B9A"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.7493 0 0 -0.75 67.6802 576.8349)",
    fontFamily: "'KozGoPr6N-Regular-83pv-RKSJ-H'",
    fontSize: "8.1415px"
  }, "\u984D"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.7493 0 0 -0.75 67.6802 567.9627)",
    fontFamily: "'KozGoPr6N-Regular-83pv-RKSJ-H'",
    fontSize: "8.1415px"
  }, "\u6CD5"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.7493 0 0 -0.75 77.64 655.6421)",
    fontFamily: "'KozGoPr6N-Regular-83pv-RKSJ-H'",
    fontSize: "8.1415px"
  }, "\u53D6"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.7493 0 0 -0.75 90.1201 655.6421)",
    fontFamily: "'KozGoPr6N-Regular-83pv-RKSJ-H'",
    fontSize: "8.1415px"
  }, "\u5F97"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.7493 0 0 -0.75 102.5999 655.6421)",
    fontFamily: "'KozGoPr6N-Regular-83pv-RKSJ-H'",
    fontSize: "8.1415px"
  }, "\u4FA1"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.7493 0 0 -0.75 115.08 655.6421)",
    fontFamily: "'KozGoPr6N-Regular-83pv-RKSJ-H'",
    fontSize: "8.1415px"
  }, "\u984D"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.7493 0 0 -0.75 127.5601 655.6421)",
    fontFamily: "'KozGoPr6N-Regular-83pv-RKSJ-H'",
    fontSize: "8.1415px"
  }, "\u53C8"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.7493 0 0 -0.75 140.0398 655.6421)",
    fontFamily: "'KozGoPr6N-Regular-83pv-RKSJ-H'",
    fontSize: "8.1415px"
  }, "\u306F"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.7493 0 0 -0.75 152.6401 655.6421)",
    fontFamily: "'KozGoPr6N-Regular-83pv-RKSJ-H'",
    fontSize: "8.1415px"
  }, "\u88FD"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.7493 0 0 -0.75 165.1202 655.6421)",
    fontFamily: "'KozGoPr6N-Regular-83pv-RKSJ-H'",
    fontSize: "8.1415px"
  }, "\u4F5C"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.7493 0 0 -0.75 177.72 655.6421)",
    fontFamily: "'KozGoPr6N-Regular-83pv-RKSJ-H'",
    fontSize: "8.1415px"
  }, "\u4FA1"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.7493 0 0 -0.75 190.1998 655.6421)",
    fontFamily: "'KozGoPr6N-Regular-83pv-RKSJ-H'",
    fontSize: "8.1415px"
  }, "\u984D"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.7493 0 0 -0.75 205.3199 655.6421)",
    fontFamily: "'KozGoPr6N-Regular-83pv-RKSJ-H'",
    fontSize: "8.1415px"
  }, "6"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.7493 0 0 -0.75 216.8401 662.1222)",
    fontFamily: "'KozGoPr6N-Regular-83pv-RKSJ-H'",
    fontSize: "8.1415px"
  }, "\u5916"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.7493 0 0 -0.75 271.7989 662.1222)",
    fontFamily: "'KozGoPr6N-Regular-83pv-RKSJ-H'",
    fontSize: "8.1415px"
  }, "\u5186"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.7493 0 0 -0.75 280.199 662.1222)",
    fontFamily: "'KozGoPr6N-Regular-83pv-RKSJ-H'",
    fontSize: "8.1415px"
  }, "\u5916"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.7493 0 0 -0.75 335.1578 662.1222)",
    fontFamily: "'KozGoPr6N-Regular-83pv-RKSJ-H'",
    fontSize: "8.1415px"
  }, "\u5186"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.7493 0 0 -0.75 343.558 662.1222)",
    fontFamily: "'KozGoPr6N-Regular-83pv-RKSJ-H'",
    fontSize: "8.1415px"
  }, "\u5916"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.7493 0 0 -0.75 398.5167 662.1222)",
    fontFamily: "'KozGoPr6N-Regular-83pv-RKSJ-H'",
    fontSize: "8.1415px"
  }, "\u5186"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.7493 0 0 -0.75 406.9168 662.1222)",
    fontFamily: "'KozGoPr6N-Regular-83pv-RKSJ-H'",
    fontSize: "8.1415px"
  }, "\u5916"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.7493 0 0 -0.75 461.8763 662.1222)",
    fontFamily: "'KozGoPr6N-Regular-83pv-RKSJ-H'",
    fontSize: "8.1415px"
  }, "\u5186"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.7493 0 0 -0.75 470.2758 662.1222)",
    fontFamily: "'KozGoPr6N-Regular-83pv-RKSJ-H'",
    fontSize: "8.1415px"
  }, "\u5916"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.7493 0 0 -0.75 525.2352 662.1222)",
    fontFamily: "'KozGoPr6N-Regular-83pv-RKSJ-H'",
    fontSize: "8.1415px"
  }, "\u5186"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.7493 0 0 -0.75 66.1201 676.7622)",
    fontFamily: "'KozGoPr6N-Regular-83pv-RKSJ-H'",
    fontSize: "8.1415px"
  }, "\u8CC3"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.7493 0 0 -0.75 74.4002 676.7622)",
    fontFamily: "'KozGoPr6N-Regular-83pv-RKSJ-H'",
    fontSize: "8.1415px"
  }, "\u8CB8"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.7493 0 0 -0.75 82.6802 676.7622)",
    fontFamily: "'KozGoPr6N-Regular-83pv-RKSJ-H'",
    fontSize: "8.1415px"
  }, "\u306E"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.7493 0 0 -0.75 90.9602 676.7622)",
    fontFamily: "'KozGoPr6N-Regular-83pv-RKSJ-H'",
    fontSize: "8.1415px"
  }, "\u7528"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.7493 0 0 -0.75 99.2399 676.7622)",
    fontFamily: "'KozGoPr6N-Regular-83pv-RKSJ-H'",
    fontSize: "8.1415px"
  }, "\u53C8"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.7493 0 0 -0.75 107.5199 676.7622)",
    fontFamily: "'KozGoPr6N-Regular-83pv-RKSJ-H'",
    fontSize: "8.1415px"
  }, "\u306F"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.7493 0 0 -0.75 115.8 676.7622)",
    fontFamily: "'KozGoPr6N-Regular-83pv-RKSJ-H'",
    fontSize: "8.1415px"
  }, "\u4E8B"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.7493 0 0 -0.75 124.08 676.7622)",
    fontFamily: "'KozGoPr6N-Regular-83pv-RKSJ-H'",
    fontSize: "8.1415px"
  }, "\u696D"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.7493 0 0 -0.75 132.36 676.7622)",
    fontFamily: "'KozGoPr6N-Regular-83pv-RKSJ-H'",
    fontSize: "8.1415px"
  }, "\u306E"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.7493 0 0 -0.75 140.64 676.7622)",
    fontFamily: "'KozGoPr6N-Regular-83pv-RKSJ-H'",
    fontSize: "8.1415px"
  }, "\u7528"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.7493 0 0 -0.75 148.9201 676.7622)",
    fontFamily: "'KozGoPr6N-Regular-83pv-RKSJ-H'",
    fontSize: "8.1415px"
  }, "\u306B"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.7493 0 0 -0.75 157.1998 676.7622)",
    fontFamily: "'KozGoPr6N-Regular-83pv-RKSJ-H'",
    fontSize: "8.1415px"
  }, "\u4F9B"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.7493 0 0 -0.75 165.4798 676.7622)",
    fontFamily: "'KozGoPr6N-Regular-83pv-RKSJ-H'",
    fontSize: "8.1415px"
  }, "\u3057"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.7493 0 0 -0.75 173.7598 676.7622)",
    fontFamily: "'KozGoPr6N-Regular-83pv-RKSJ-H'",
    fontSize: "8.1415px"
  }, "\u305F"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.7493 0 0 -0.75 182.0398 676.7622)",
    fontFamily: "'KozGoPr6N-Regular-83pv-RKSJ-H'",
    fontSize: "8.1415px"
  }, "\u5E74"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.7493 0 0 -0.75 190.1998 676.7622)",
    fontFamily: "'KozGoPr6N-Regular-83pv-RKSJ-H'",
    fontSize: "8.1415px"
  }, "\u6708"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.7493 0 0 -0.75 205.3199 676.7622)",
    fontFamily: "'KozGoPr6N-Regular-83pv-RKSJ-H'",
    fontSize: "8.1415px"
  }, "5"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.7493 0 0 -0.75 66.1201 697.8823)",
    fontFamily: "'KozGoPr6N-Regular-83pv-RKSJ-H'",
    fontSize: "8.1415px"
  }, "\u5951"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.7493 0 0 -0.75 97.199 697.8823)",
    fontFamily: "'KozGoPr6N-Regular-83pv-RKSJ-H'",
    fontSize: "8.1415px"
  }, "\u7D04"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.7493 0 0 -0.75 128.1592 697.8823)",
    fontFamily: "'KozGoPr6N-Regular-83pv-RKSJ-H'",
    fontSize: "8.1415px"
  }, "\u5E74"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.7493 0 0 -0.75 159.2381 697.8823)",
    fontFamily: "'KozGoPr6N-Regular-83pv-RKSJ-H'",
    fontSize: "8.1415px"
  }, "\u6708"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.7493 0 0 -0.75 190.1979 697.8823)",
    fontFamily: "'KozGoPr6N-Regular-83pv-RKSJ-H'",
    fontSize: "8.1415px"
  }, "\u65E5"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.7493 0 0 -0.75 205.318 697.8823)",
    fontFamily: "'KozGoPr6N-Regular-83pv-RKSJ-H'",
    fontSize: "8.1415px"
  }, "4"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.7493 0 0 -0.75 235.1983 697.8823)",
    fontFamily: "'KozGoPr6N-Regular-83pv-RKSJ-H'",
    fontSize: "8.1415px"
  }, "\u30FB"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.7493 0 0 -0.75 253.9183 697.8823)",
    fontFamily: "'KozGoPr6N-Regular-83pv-RKSJ-H'",
    fontSize: "8.1415px"
  }, "\u30FB"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.7493 0 0 -0.75 298.5579 697.8823)",
    fontFamily: "'KozGoPr6N-Regular-83pv-RKSJ-H'",
    fontSize: "8.1415px"
  }, "\u30FB"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.7493 0 0 -0.75 317.2779 697.8823)",
    fontFamily: "'KozGoPr6N-Regular-83pv-RKSJ-H'",
    fontSize: "8.1415px"
  }, "\u30FB"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.7493 0 0 -0.75 361.9183 697.8823)",
    fontFamily: "'KozGoPr6N-Regular-83pv-RKSJ-H'",
    fontSize: "8.1415px"
  }, "\u30FB"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.7493 0 0 -0.75 380.6383 697.8823)",
    fontFamily: "'KozGoPr6N-Regular-83pv-RKSJ-H'",
    fontSize: "8.1415px"
  }, "\u30FB"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.7493 0 0 -0.75 425.2779 697.8823)",
    fontFamily: "'KozGoPr6N-Regular-83pv-RKSJ-H'",
    fontSize: "8.1415px"
  }, "\u30FB"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.7493 0 0 -0.75 443.9979 697.8823)",
    fontFamily: "'KozGoPr6N-Regular-83pv-RKSJ-H'",
    fontSize: "8.1415px"
  }, "\u30FB"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.7493 0 0 -0.75 488.6383 697.8823)",
    fontFamily: "'KozGoPr6N-Regular-83pv-RKSJ-H'",
    fontSize: "8.1415px"
  }, "\u30FB"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.7493 0 0 -0.75 507.3583 697.8823)",
    fontFamily: "'KozGoPr6N-Regular-83pv-RKSJ-H'",
    fontSize: "8.1415px"
  }, "\u30FB"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.7493 0 0 -0.75 66.1201 719.0021)",
    fontFamily: "'KozGoPr6N-Regular-83pv-RKSJ-H'",
    fontSize: "8.1415px"
  }, "\u7D30"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.7493 0 0 -0.75 190.1998 719.0021)",
    fontFamily: "'KozGoPr6N-Regular-83pv-RKSJ-H'",
    fontSize: "8.1415px"
  }, "\u76EE"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.7493 0 0 -0.75 205.3199 719.0021)",
    fontFamily: "'KozGoPr6N-Regular-83pv-RKSJ-H'",
    fontSize: "8.1415px"
  }, "3"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.7493 0 0 -0.75 66.1201 740.1222)",
    fontFamily: "'KozGoPr6N-Regular-83pv-RKSJ-H'",
    fontSize: "8.1415px"
  }, "\u69CB"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.7493 0 0 -0.75 190.1998 740.1222)",
    fontFamily: "'KozGoPr6N-Regular-83pv-RKSJ-H'",
    fontSize: "8.1415px"
  }, "\u9020"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.7493 0 0 -0.75 205.3199 740.1222)",
    fontFamily: "'KozGoPr6N-Regular-83pv-RKSJ-H'",
    fontSize: "8.1415px"
  }, "2"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.7493 0 0 -0.75 412.8004 776.0021)",
    fontFamily: "'KozGoPr6N-Regular-83pv-RKSJ-H'",
    fontSize: "10.01px"
  }, "\uFF08"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.7493 0 0 -0.75 523.6788 776.0021)",
    fontFamily: "'KozGoPr6N-Regular-83pv-RKSJ-H'",
    fontSize: "10.01px"
  }, "\uFF09"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.7493 0 0 -0.75 53.0398 797.8422)",
    fontFamily: "'KozGoPr6N-Regular-83pv-RKSJ-H'",
    fontSize: "12.5459px"
  }, "\u65E7"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.7493 0 0 -0.75 62.64 797.8422)",
    fontFamily: "'KozGoPr6N-Regular-83pv-RKSJ-H'",
    fontSize: "12.5459px"
  }, "\u56FD"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.7493 0 0 -0.75 72.2399 797.8422)",
    fontFamily: "'KozGoPr6N-Regular-83pv-RKSJ-H'",
    fontSize: "12.5459px"
  }, "\u5916"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.7493 0 0 -0.75 81.8401 797.8422)",
    fontFamily: "'KozGoPr6N-Regular-83pv-RKSJ-H'",
    fontSize: "12.5459px"
  }, "\u30EA"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.7493 0 0 -0.75 91.44 797.8422)",
    fontFamily: "'KozGoPr6N-Regular-83pv-RKSJ-H'",
    fontSize: "12.5459px"
  }, "\u30FC"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.7493 0 0 -0.75 101.0398 797.8422)",
    fontFamily: "'KozGoPr6N-Regular-83pv-RKSJ-H'",
    fontSize: "12.5459px"
  }, "\u30B9"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.7493 0 0 -0.75 110.64 797.8422)",
    fontFamily: "'KozGoPr6N-Regular-83pv-RKSJ-H'",
    fontSize: "12.5459px"
  }, "\u671F"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.7493 0 0 -0.75 120.2399 797.8422)",
    fontFamily: "'KozGoPr6N-Regular-83pv-RKSJ-H'",
    fontSize: "12.5459px"
  }, "\u9593"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.7493 0 0 -0.75 129.8401 797.8422)",
    fontFamily: "'KozGoPr6N-Regular-83pv-RKSJ-H'",
    fontSize: "12.5459px"
  }, "\u5B9A"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.7493 0 0 -0.75 139.44 797.8422)",
    fontFamily: "'KozGoPr6N-Regular-83pv-RKSJ-H'",
    fontSize: "12.5459px"
  }, "\u984D"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.7493 0 0 -0.75 149.0398 797.8422)",
    fontFamily: "'KozGoPr6N-Regular-83pv-RKSJ-H'",
    fontSize: "12.5459px"
  }, "\u6CD5"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.7493 0 0 -0.75 158.6401 797.8422)",
    fontFamily: "'KozGoPr6N-Regular-83pv-RKSJ-H'",
    fontSize: "12.5459px"
  }, "\u82E5"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.7493 0 0 -0.75 168.2399 797.8422)",
    fontFamily: "'KozGoPr6N-Regular-83pv-RKSJ-H'",
    fontSize: "12.5459px"
  }, "\u3057"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.7493 0 0 -0.75 177.8401 797.8422)",
    fontFamily: "'KozGoPr6N-Regular-83pv-RKSJ-H'",
    fontSize: "12.5459px"
  }, "\u304F"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.7493 0 0 -0.75 187.44 797.8422)",
    fontFamily: "'KozGoPr6N-Regular-83pv-RKSJ-H'",
    fontSize: "12.5459px"
  }, "\u306F"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.7493 0 0 -0.75 197.0398 797.8422)",
    fontFamily: "'KozGoPr6N-Regular-83pv-RKSJ-H'",
    fontSize: "12.5459px"
  }, "\u65E7"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.7493 0 0 -0.75 206.6401 797.8422)",
    fontFamily: "'KozGoPr6N-Regular-83pv-RKSJ-H'",
    fontSize: "12.5459px"
  }, "\u30EA"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.7493 0 0 -0.75 216.2399 797.8422)",
    fontFamily: "'KozGoPr6N-Regular-83pv-RKSJ-H'",
    fontSize: "12.5459px"
  }, "\u30FC"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.7493 0 0 -0.75 225.8401 797.8422)",
    fontFamily: "'KozGoPr6N-Regular-83pv-RKSJ-H'",
    fontSize: "12.5459px"
  }, "\u30B9"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.7493 0 0 -0.75 235.44 797.8422)",
    fontFamily: "'KozGoPr6N-Regular-83pv-RKSJ-H'",
    fontSize: "12.5459px"
  }, "\u671F"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.7493 0 0 -0.75 245.0399 797.8422)",
    fontFamily: "'KozGoPr6N-Regular-83pv-RKSJ-H'",
    fontSize: "12.5459px"
  }, "\u9593"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.7493 0 0 -0.75 254.6397 797.8422)",
    fontFamily: "'KozGoPr6N-Regular-83pv-RKSJ-H'",
    fontSize: "12.5459px"
  }, "\u5B9A"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.7493 0 0 -0.75 264.2403 797.8422)",
    fontFamily: "'KozGoPr6N-Regular-83pv-RKSJ-H'",
    fontSize: "12.5459px"
  }, "\u984D"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.7493 0 0 -0.75 53.0398 787.2821)",
    fontFamily: "'KozGoPr6N-Regular-83pv-RKSJ-H'",
    fontSize: "12.5459px"
  }, "\u6CD5"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.7493 0 0 -0.75 62.64 787.2821)",
    fontFamily: "'KozGoPr6N-Regular-83pv-RKSJ-H'",
    fontSize: "12.5459px"
  }, "\u53C8"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.7493 0 0 -0.75 72.2399 787.2821)",
    fontFamily: "'KozGoPr6N-Regular-83pv-RKSJ-H'",
    fontSize: "12.5459px"
  }, "\u306F"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.7493 0 0 -0.75 81.8401 787.2821)",
    fontFamily: "'KozGoPr6N-Regular-83pv-RKSJ-H'",
    fontSize: "12.5459px"
  }, "\u30EA"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.7493 0 0 -0.75 91.44 787.2821)",
    fontFamily: "'KozGoPr6N-Regular-83pv-RKSJ-H'",
    fontSize: "12.5459px"
  }, "\u30FC"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.7493 0 0 -0.75 101.0398 787.2821)",
    fontFamily: "'KozGoPr6N-Regular-83pv-RKSJ-H'",
    fontSize: "12.5459px"
  }, "\u30B9"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.7493 0 0 -0.75 110.64 787.2821)",
    fontFamily: "'KozGoPr6N-Regular-83pv-RKSJ-H'",
    fontSize: "12.5459px"
  }, "\u671F"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.7493 0 0 -0.75 120.2399 787.2821)",
    fontFamily: "'KozGoPr6N-Regular-83pv-RKSJ-H'",
    fontSize: "12.5459px"
  }, "\u9593"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.7493 0 0 -0.75 129.8401 787.2821)",
    fontFamily: "'KozGoPr6N-Regular-83pv-RKSJ-H'",
    fontSize: "12.5459px"
  }, "\u5B9A"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.7493 0 0 -0.75 139.44 787.2821)",
    fontFamily: "'KozGoPr6N-Regular-83pv-RKSJ-H'",
    fontSize: "12.5459px"
  }, "\u984D"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.7493 0 0 -0.75 149.0398 787.2821)",
    fontFamily: "'KozGoPr6N-Regular-83pv-RKSJ-H'",
    fontSize: "12.5459px"
  }, "\u6CD5"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.7493 0 0 -0.75 158.6401 787.2821)",
    fontFamily: "'KozGoPr6N-Regular-83pv-RKSJ-H'",
    fontSize: "12.5459px"
  }, "\u306B"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.7493 0 0 -0.75 168.2399 787.2821)",
    fontFamily: "'KozGoPr6N-Regular-83pv-RKSJ-H'",
    fontSize: "12.5459px"
  }, "\u3088"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.7493 0 0 -0.75 177.8401 787.2821)",
    fontFamily: "'KozGoPr6N-Regular-83pv-RKSJ-H'",
    fontSize: "12.5459px"
  }, "\u308B"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.7493 0 0 -0.75 187.44 787.2821)",
    fontFamily: "'KozGoPr6N-Regular-83pv-RKSJ-H'",
    fontSize: "12.5459px"
  }, "\u511F"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.7493 0 0 -0.75 197.0398 787.2821)",
    fontFamily: "'KozGoPr6N-Regular-83pv-RKSJ-H'",
    fontSize: "12.5459px"
  }, "\u5374"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.7493 0 0 -0.75 206.6401 787.2821)",
    fontFamily: "'KozGoPr6N-Regular-83pv-RKSJ-H'",
    fontSize: "12.5459px"
  }, "\u984D"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.7493 0 0 -0.75 216.2399 787.2821)",
    fontFamily: "'KozGoPr6N-Regular-83pv-RKSJ-H'",
    fontSize: "12.5459px"
  }, "\u306E"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.7493 0 0 -0.75 225.8401 787.2821)",
    fontFamily: "'KozGoPr6N-Regular-83pv-RKSJ-H'",
    fontSize: "12.5459px"
  }, "\u8A08"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.7493 0 0 -0.75 235.44 787.2821)",
    fontFamily: "'KozGoPr6N-Regular-83pv-RKSJ-H'",
    fontSize: "12.5459px"
  }, "\u7B97"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.7493 0 0 -0.75 245.0399 787.2821)",
    fontFamily: "'KozGoPr6N-Regular-83pv-RKSJ-H'",
    fontSize: "12.5459px"
  }, "\u306B"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.7493 0 0 -0.75 254.6397 787.2821)",
    fontFamily: "'KozGoPr6N-Regular-83pv-RKSJ-H'",
    fontSize: "12.5459px"
  }, "\u95A2"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.7493 0 0 -0.75 264.2403 787.2821)",
    fontFamily: "'KozGoPr6N-Regular-83pv-RKSJ-H'",
    fontSize: "12.5459px"
  }, "\u3059"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.7493 0 0 -0.75 53.0398 776.722)",
    fontFamily: "'KozGoPr6N-Regular-83pv-RKSJ-H'",
    fontSize: "12.5459px"
  }, "\u308B"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.7493 0 0 -0.75 62.64 776.722)",
    fontFamily: "'KozGoPr6N-Regular-83pv-RKSJ-H'",
    fontSize: "12.5459px"
  }, "\u660E"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.7493 0 0 -0.75 72.2399 776.722)",
    fontFamily: "'KozGoPr6N-Regular-83pv-RKSJ-H'",
    fontSize: "12.5459px"
  }, "\u7D30"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.7493 0 0 -0.75 81.8401 776.722)",
    fontFamily: "'KozGoPr6N-Regular-83pv-RKSJ-H'",
    fontSize: "12.5459px"
  }, "\u66F8"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.7493 0 0 -0.75 536.4003 797.8422)",
    fontFamily: "'KozGoPr6N-Regular-83pv-RKSJ-H'",
    fontSize: "12.5459px"
  }, "\u5225"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.7493 0 0 -0.75 536.4003 787.2916)",
    fontFamily: "'KozGoPr6N-Regular-83pv-RKSJ-H'",
    fontSize: "12.5459px"
  }, "\u8868"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.7493 0 0 -0.75 536.4003 776.7411)",
    fontFamily: "'KozGoPr6N-Regular-83pv-RKSJ-H'",
    fontSize: "12.5459px"
  }, "\u5341"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.7493 0 0 -0.75 536.4003 766.0704)",
    fontFamily: "'KozGoPr6N-Regular-83pv-RKSJ-H'",
    fontSize: "12.5459px"
  }, "\u516D"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.7493 0 0 -0.75 536.4003 755.5199)",
    fontFamily: "'KozGoPr6N-Regular-83pv-RKSJ-H'",
    fontSize: "12.5459px"
  }, "\u3223"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.7493 0 0 -0.75 536.4003 744.9694)",
    fontFamily: "'KozGoPr6N-Regular-83pv-RKSJ-H'",
    fontSize: "12.5459px"
  }), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.7493 0 0 -0.75 536.4003 734.4188)",
    fontFamily: "'KozGoPr6N-Regular-83pv-RKSJ-H'",
    fontSize: "12.5459px"
  }, "\u4EE4"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.7493 0 0 -0.75 536.4003 723.8683)",
    fontFamily: "'KozGoPr6N-Regular-83pv-RKSJ-H'",
    fontSize: "12.5459px"
  }, "\u56DB"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.7493 0 0 -0.75 536.4003 713.3177)",
    fontFamily: "'KozGoPr6N-Regular-83pv-RKSJ-H'",
    fontSize: "12.5459px"
  }, "\u30FB"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.7493 0 0 -0.75 536.4003 702.6471)",
    fontFamily: "'KozGoPr6N-Regular-83pv-RKSJ-H'",
    fontSize: "12.5459px"
  }, "\u56DB"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.7493 0 0 -0.75 536.4003 692.0966)",
    fontFamily: "'KozGoPr6N-Regular-83pv-RKSJ-H'",
    fontSize: "12.5459px"
  }, "\u30FB"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.7493 0 0 -0.75 536.4003 681.546)",
    fontFamily: "'KozGoPr6N-Regular-83pv-RKSJ-H'",
    fontSize: "12.5459px"
  }, "\u4E00"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.7493 0 0 -0.75 536.4003 670.9955)",
    fontFamily: "'KozGoPr6N-Regular-83pv-RKSJ-H'",
    fontSize: "12.5459px"
  }, "\u4EE5"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.7493 0 0 -0.75 536.4003 660.4449)",
    fontFamily: "'KozGoPr6N-Regular-83pv-RKSJ-H'",
    fontSize: "12.5459px"
  }, "\u5F8C"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.7493 0 0 -0.75 536.4003 649.894)",
    fontFamily: "'KozGoPr6N-Regular-83pv-RKSJ-H'",
    fontSize: "12.5459px"
  }, "\u7D42"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.7493 0 0 -0.75 536.4003 639.3435)",
    fontFamily: "'KozGoPr6N-Regular-83pv-RKSJ-H'",
    fontSize: "12.5459px"
  }, "\u4E86"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.7493 0 0 -0.75 536.4003 628.6729)",
    fontFamily: "'KozGoPr6N-Regular-83pv-RKSJ-H'",
    fontSize: "12.5459px"
  }, "\u4E8B"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.7493 0 0 -0.75 536.4003 618.1223)",
    fontFamily: "'KozGoPr6N-Regular-83pv-RKSJ-H'",
    fontSize: "12.5459px"
  }, "\u696D"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.7493 0 0 -0.75 536.4003 607.5717)",
    fontFamily: "'KozGoPr6N-Regular-83pv-RKSJ-H'",
    fontSize: "12.5459px"
  }, "\u5E74"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.7493 0 0 -0.75 536.4003 597.0212)",
    fontFamily: "'KozGoPr6N-Regular-83pv-RKSJ-H'",
    fontSize: "12.5459px"
  }, "\u5EA6"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.7493 0 0 -0.75 536.4003 586.4706)",
    fontFamily: "'KozGoPr6N-Regular-83pv-RKSJ-H'",
    fontSize: "12.5459px"
  }, "\u53C8"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.7493 0 0 -0.75 536.4003 575.9201)",
    fontFamily: "'KozGoPr6N-Regular-83pv-RKSJ-H'",
    fontSize: "12.5459px"
  }, "\u306F"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.7493 0 0 -0.75 536.4003 565.2495)",
    fontFamily: "'KozGoPr6N-Regular-83pv-RKSJ-H'",
    fontSize: "12.5459px"
  }, "\u9023"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.7493 0 0 -0.75 536.4003 554.6989)",
    fontFamily: "'KozGoPr6N-Regular-83pv-RKSJ-H'",
    fontSize: "12.5459px"
  }, "\u7D50"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.7493 0 0 -0.75 536.4003 544.1484)",
    fontFamily: "'KozGoPr6N-Regular-83pv-RKSJ-H'",
    fontSize: "12.5459px"
  }, "\u4E8B"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.7493 0 0 -0.75 536.4003 533.5978)",
    fontFamily: "'KozGoPr6N-Regular-83pv-RKSJ-H'",
    fontSize: "12.5459px"
  }, "\u696D"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.7493 0 0 -0.75 536.4003 523.0473)",
    fontFamily: "'KozGoPr6N-Regular-83pv-RKSJ-H'",
    fontSize: "12.5459px"
  }, "\u5E74"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.7493 0 0 -0.75 536.4003 512.4968)",
    fontFamily: "'KozGoPr6N-Regular-83pv-RKSJ-H'",
    fontSize: "12.5459px"
  }, "\u5EA6"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.7493 0 0 -0.75 536.4003 501.9462)",
    fontFamily: "'KozGoPr6N-Regular-83pv-RKSJ-H'",
    fontSize: "12.5459px"
  }, "\u5206"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.7493 0 0 -0.75 337.44 791.9619)",
    fontFamily: "'KozGoPr6N-Regular-83pv-RKSJ-H'",
    fontSize: "8.6753px"
  }, "\u30FB"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.7493 0 0 -0.75 338.16 791.9619)",
    fontFamily: "'KozGoPr6N-Regular-83pv-RKSJ-H'",
    fontSize: "8.6753px"
  }), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.7493 0 0 -0.75 344.8792 791.9619)",
    fontFamily: "'KozGoPr6N-Regular-83pv-RKSJ-H'",
    fontSize: "8.6753px"
  }), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.7493 0 0 -0.75 351.5977 791.9619)",
    fontFamily: "'KozGoPr6N-Regular-83pv-RKSJ-H'",
    fontSize: "8.6753px"
  }), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.7493 0 0 -0.75 357.317 791.9619)",
    fontFamily: "'KozGoPr6N-Regular-83pv-RKSJ-H'",
    fontSize: "8.6753px"
  }, "\u30FB"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.7493 0 0 -0.75 337.44 784.2821)",
    fontFamily: "'KozGoPr6N-Regular-83pv-RKSJ-H'",
    fontSize: "8.6753px"
  }, "\u30FB"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.7493 0 0 -0.75 338.16 784.2821)",
    fontFamily: "'KozGoPr6N-Regular-83pv-RKSJ-H'",
    fontSize: "8.6753px"
  }), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.7493 0 0 -0.75 344.8792 784.2821)",
    fontFamily: "'KozGoPr6N-Regular-83pv-RKSJ-H'",
    fontSize: "8.6753px"
  }), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.7493 0 0 -0.75 351.5977 784.2821)",
    fontFamily: "'KozGoPr6N-Regular-83pv-RKSJ-H'",
    fontSize: "8.6753px"
  }), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.7493 0 0 -0.75 357.317 784.2821)",
    fontFamily: "'KozGoPr6N-Regular-83pv-RKSJ-H'",
    fontSize: "8.6753px"
  }, "\u30FB"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.7493 0 0 -0.75 384.4798 787.4019)",
    fontFamily: "'KozGoPr6N-Regular-83pv-RKSJ-H'",
    fontSize: "11.3447px"
  }, "\u6CD5"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.7493 0 0 -0.75 393.1202 787.4019)",
    fontFamily: "'KozGoPr6N-Regular-83pv-RKSJ-H'",
    fontSize: "11.3447px"
  }, "\u4EBA"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.7493 0 0 -0.75 401.7599 787.4019)",
    fontFamily: "'KozGoPr6N-Regular-83pv-RKSJ-H'",
    fontSize: "11.3447px"
  }, "\u540D"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.7493 0 0 -0.75 281.0399 796.4019)",
    fontFamily: "'KozGoPr6N-Regular-83pv-RKSJ-H'",
    fontSize: "10.01px"
  }, "\u4E8B"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.7493 0 0 -0.75 288.72 796.4019)",
    fontFamily: "'KozGoPr6N-Regular-83pv-RKSJ-H'",
    fontSize: "10.01px"
  }, "\u696D"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.7493 0 0 -0.75 296.4002 796.4019)",
    fontFamily: "'KozGoPr6N-Regular-83pv-RKSJ-H'",
    fontSize: "10.01px"
  }, "\u5E74"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.7493 0 0 -0.75 304.0797 796.4019)",
    fontFamily: "'KozGoPr6N-Regular-83pv-RKSJ-H'",
    fontSize: "10.01px"
  }, "\u5EA6"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.7493 0 0 -0.75 281.0399 787.7622)",
    fontFamily: "'KozGoPr6N-Regular-83pv-RKSJ-H'",
    fontSize: "10.01px"
  }, "\u53C8"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.7493 0 0 -0.75 288.72 787.7622)",
    fontFamily: "'KozGoPr6N-Regular-83pv-RKSJ-H'",
    fontSize: "10.01px"
  }, "\u306F"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.7493 0 0 -0.75 296.4002 787.7622)",
    fontFamily: "'KozGoPr6N-Regular-83pv-RKSJ-H'",
    fontSize: "10.01px"
  }, "\u9023"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.7493 0 0 -0.75 304.0797 787.7622)",
    fontFamily: "'KozGoPr6N-Regular-83pv-RKSJ-H'",
    fontSize: "10.01px"
  }, "\u7D50"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.7493 0 0 -0.75 281.0399 779.1222)",
    fontFamily: "'KozGoPr6N-Regular-83pv-RKSJ-H'",
    fontSize: "10.01px"
  }, "\u4E8B"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.7493 0 0 -0.75 288.72 779.1222)",
    fontFamily: "'KozGoPr6N-Regular-83pv-RKSJ-H'",
    fontSize: "10.01px"
  }, "\u696D"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.7493 0 0 -0.75 296.4002 779.1222)",
    fontFamily: "'KozGoPr6N-Regular-83pv-RKSJ-H'",
    fontSize: "10.01px"
  }, "\u5E74"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.7493 0 0 -0.75 304.0797 779.1222)",
    fontFamily: "'KozGoPr6N-Regular-83pv-RKSJ-H'",
    fontSize: "10.01px"
  }, "\u5EA6"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.7493 0 0 -0.75 55.1997 752.6023)",
    fontFamily: "'KozGoPr6N-Regular-83pv-RKSJ-H'",
    fontSize: "8.1415px"
  }, "\u8CC7"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.7493 0 0 -0.75 55.1997 730.1807)",
    fontFamily: "'KozGoPr6N-Regular-83pv-RKSJ-H'",
    fontSize: "8.1415px"
  }, "\u7523"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.7493 0 0 -0.75 55.1997 707.8795)",
    fontFamily: "'KozGoPr6N-Regular-83pv-RKSJ-H'",
    fontSize: "8.1415px"
  }, "\u533A"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.7493 0 0 -0.75 55.1997 685.4583)",
    fontFamily: "'KozGoPr6N-Regular-83pv-RKSJ-H'",
    fontSize: "8.1415px"
  }, "\u5206"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.7493 0 0 -0.75 66.1201 761.2419)",
    fontFamily: "'KozGoPr6N-Regular-83pv-RKSJ-H'",
    fontSize: "8.1415px"
  }, "\u7A2E"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.7493 0 0 -0.75 190.1998 761.2419)",
    fontFamily: "'KozGoPr6N-Regular-83pv-RKSJ-H'",
    fontSize: "8.1415px"
  }, "\u985E"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.7493 0 0 -0.75 205.3199 761.2419)",
    fontFamily: "'KozGoPr6N-Regular-83pv-RKSJ-H'",
    fontSize: "8.1415px"
  }, "1"), /*#__PURE__*/React.createElement("g", {
    id: "g756"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path758",
    d: "M278.5,773.2h0.8v33.8h-0.8V773.2z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g760"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path762",
    d: "M64.8,285.4h0.1v487.8h-0.1V285.4z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g764"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path766",
    d: "M278.9,63.7h0.1v709.6h-0.1V63.7z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g768"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path770",
    d: "M313.4,774.1h0.1v32.2h-0.1V774.1z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g772"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path774",
    d: "M382.6,774.1h0.1v32.2h-0.1V774.1z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g776"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path778",
    d: "M411.4,774.1h0.1v32.2h-0.1V774.1z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g780"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path782",
    d: "M532,42.2h0.8v764H532V42.2z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g784"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path786",
    d: "M51,42.2h0.8v731.9H51V42.2z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g788"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path790",
    d: "M64.8,63.7h0.1v126.7h-0.1V63.7z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g792"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path794",
    d: "M197.3,63.7h0.1v709.6h-0.1V63.7z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g796"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path798",
    d: "M215.5,63.7h0.1v709.6h-0.1V63.7z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g800"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path802",
    d: "M342.2,63.7h0.1v709.6h-0.1V63.7z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g804"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path806",
    d: "M405.6,63.7h0.1v709.6h-0.1V63.7z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g808"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path810",
    d: "M469,63.7h0.1v709.6H469V63.7z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g812"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path814",
    d: "M76.3,369.9h0.1V668h-0.1V369.9z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g816"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path818",
    d: "M87.8,84.8H88V127h-0.1V84.8z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g820"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path822",
    d: "M279.4,806.2h253.4v0.8H279.4V806.2z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g824"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path826",
    d: "M51.8,773.2h481v0.8h-481V773.2z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g828"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path830",
    d: "M64.9,752.5h467v0.1h-467V752.5z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g832"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path834",
    d: "M64.9,731.4h467v0.1h-467V731.4z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g836"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path838",
    d: "M64.9,710.2h467v0.1h-467V710.2z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g840"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path842",
    d: "M64.9,689.1h467v0.1h-467V689.1z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g844"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path846",
    d: "M51.8,668H532v0.1H51.8V668z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g848"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path850",
    d: "M76.4,646.9H532v0.1H76.4V646.9z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g852"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path854",
    d: "M76.4,623.4H532v0.1H76.4V623.4z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g856"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path858",
    d: "M76.4,602.2H532v0.1H76.4V602.2z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g860"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path862",
    d: "M76.4,581.1H532v0.1H76.4V581.1z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g864"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path866",
    d: "M64.9,560h467v0.1h-467V560z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g868"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path870",
    d: "M76.4,538.9H532v0.1H76.4V538.9z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g872"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path874",
    d: "M76.4,517.8H532v0.1H76.4V517.8z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g876"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path878",
    d: "M76.4,496.6H532v0.1H76.4V496.6z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g880"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path882",
    d: "M76.4,475.5H532v0.1H76.4V475.5z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g884"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path886",
    d: "M76.4,454.4H532v0.1H76.4V454.4z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g888"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path890",
    d: "M64.9,433.3h467v0.1h-467V433.3z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g892"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path894",
    d: "M76.4,412.2H532v0.1H76.4V412.2z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g896"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path898",
    d: "M76.4,391H532v0.1H76.4V391z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g900"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path902",
    d: "M51.8,369.9H532v0.1H51.8V369.9z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g904"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path906",
    d: "M64.9,348.8h467v0.1h-467V348.8z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g908"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path910",
    d: "M64.9,327.7h467v0.1h-467V327.7z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g912"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path914",
    d: "M64.9,306.6h467v0.1h-467V306.6z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g916"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path918",
    d: "M51.8,285.4H532v0.1H51.8V285.4z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g920"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path922",
    d: "M51.8,264.3H532v0.1H51.8V264.3z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g924"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path926",
    d: "M51.8,243.2H532v0.1H51.8V243.2z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g928"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path930",
    d: "M51.8,211.5H532v0.1H51.8V211.5z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g932"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path934",
    d: "M51.8,190.4H532v0.1H51.8V190.4z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g936"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path938",
    d: "M64.9,169.3h467v0.1h-467V169.3z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g940"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path942",
    d: "M51.8,148.2H532v0.1H51.8V148.2z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g944"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path946",
    d: "M64.9,127h467v0.1h-467V127z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g948"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path950",
    d: "M88,105.9h444v0.1H88L88,105.9z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g952"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path954",
    d: "M64.9,84.8h467v0.1h-467V84.8z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g956"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path958",
    d: "M51.8,63.7H532v0.1H51.8V63.7z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g960"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path962",
    d: "M51.8,42.2h481V43h-481V42.2z"
  })), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.75 0 0 -0.75 155.8799 222.922)",
    fontFamily: "'KozGoPr6N-Regular-83pv-RKSJ-H'",
    fontSize: "8.1333px"
  }, "("), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.75 0 0 -0.75 159 222.922)",
    fontFamily: "'KozGoPr6N-Regular-83pv-RKSJ-H'",
    fontSize: "8.1333px"
  }, "2"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.75 0 0 -0.75 162.1202 222.922)",
    fontFamily: "'KozGoPr6N-Regular-83pv-RKSJ-H'",
    fontSize: "8.1333px"
  }, "5"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.75 0 0 -0.75 165.2403 222.922)",
    fontFamily: "'KozGoPr6N-Regular-83pv-RKSJ-H'",
    fontSize: "8.1333px"
  }, ")"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.75 0 0 -0.75 155.8799 213.6818)",
    fontFamily: "'KozGoPr6N-Regular-83pv-RKSJ-H'",
    fontSize: "8.1333px"
  }, "("), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.75 0 0 -0.75 159 213.6818)",
    fontFamily: "'KozGoPr6N-Regular-83pv-RKSJ-H'",
    fontSize: "8.1333px"
  }, "2"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.75 0 0 -0.75 162.1202 213.6818)",
    fontFamily: "'KozGoPr6N-Regular-83pv-RKSJ-H'",
    fontSize: "8.1333px"
  }, "4"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.75 0 0 -0.75 165.2403 213.6818)",
    fontFamily: "'KozGoPr6N-Regular-83pv-RKSJ-H'",
    fontSize: "8.1333px"
  }, ")"), /*#__PURE__*/React.createElement("g", {
    id: "g972"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path974",
    d: "M154.7,220.2h14.9v0.5h-14.9V220.2z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackground);
export default __webpack_public_path__ + "static/media/background.b90b1c54b1ccf8de21a002b57601f1fd.svg";
export { ForwardRef as ReactComponent };